import React from "react";
import AccountReceivableDiscountDetailReasonAttributeModule from "./attributes/AccountReceivableDiscountAttributeModule.js";
import AccountReceivableReversalReasonAttributeModule from "./attributes/AccountReceivableReversalReasonAttributeModule.js";
import BankAccountAttributeModule from "./attributes/BankAccountAttributeModule.js";
import BankAdjustmentReasonAttributeModule from "./attributes/BankAdjustmentReasonAttributeModule.js";
import BinLocationAttributeModule from "./attributes/BinLocationAttributeModule.js";
import BoxTypeAttributeModule from "./attributes/BoxTypeAttributeModule.js";
import BusinessDivisionAttributeModule from "./attributes/BusinessDivisionAttributeModule.js";
import CityAttributeModule from "./attributes/CityAttributeModule.js";
import ColorAttributeModule from "./attributes/ColorAttributeModule.js";
import CommentAttributeModule from "./attributes/CommentAttributeModule.js";
import CompositionTypeAttributeModule from "./attributes/CompositionTypeAttributeModule.js";
import ContentAttributeModule from "./attributes/ContentAttributeModule.js";
import CountryAttributeModule from "./attributes/CountryAttributeModule.js";
import CurrencyAttributeModule from "./attributes/CurrencyAttributeModule.js";
import CurrencyExchangeRateAttributeModule from "./attributes/CurrencyExchangeRateAttributeModule.js";
import CustomerDeliveryAttributeModule from "./attributes/CustomerDeliveryAttributeModule.js";
import CustomerDivisionAttributeModule from "./attributes/CustomerDivisionAttributeModule.js";
import CustomerSalesZoneAttributeModule from "./attributes/CustomerSalesZoneAttributeModule.js";
import CustomerSpecialTypeAttributeModule from "./attributes/CustomerSpecialTypeModule.js";
import CustomerTenderCancelReasonAttributeModule from "./attributes/CustomerTenderCancelReasonAttributeModule.js";
import CustomerTenderReasonAttributeModule from "./attributes/CustomerTenderReasonAttributeModule.js";
import CustomerTenderUnApprovalReasonAttributeModule from "./attributes/CustomerTenderUnApprovalReasonAttributeModule.js";
import CustomerTypeAttributeModule from "./attributes/CustomerTypeModule.js";
import DepositCancelReasonAttributeModule from "./attributes/DepositCancelReasonAttributeModule.js";
import DepositReversalReasonAttributeModule from "./attributes/DepositReversalReasonAttributeModule.js";
import EmployeeAttributeModule from "./attributes/EmployeeAttributeModule.js";
import ExpenseSubTypeAttributeModule from "./attributes/ExpenseSubTypeAttributeModule.js";
import ExpenseTypeAttributeModule from "./attributes/ExpenseTypeAttributeModule.js";
import FabricDetailAttributeModule from "./attributes/FabricDetailAttributeModule.js";
import FabricVendorMiscellaneousCostDetailAttributeModule from "./attributes/FabricVendorMiscellaneousCostDetailAttributeModule.js";
import FiscalYearAttributeModule from "./attributes/FiscalYearAttributeModule.js";
import FobCityAttributeModule from "./attributes/FobCityAttributeModule.js";
import FreightMethodAttributeModule from "./attributes/FreightMethodAttributeModule.js";
import GeneralLedgerAccountAttributeModule from "./attributes/GeneralLedgerAccountAttributeModule.js";
import GeneralLedgerAccountTypeAttributeModule from "./attributes/GeneralLedgerAccountTypeAttributeModule.js";
import HarmonizedTariffScheduleAttributeModule from "./attributes/HarmonizedTariffScheduleAttributeModule.js";
import IncoTermAttributeModule from "./attributes/IncoTermAttributeModule.js";
import InventoryAdjustmentReasonAttributeModule from "./attributes/InventoryAdjustmentReasonAttributeModule.js";
import InvoiceCancelReasonAttributeModule from "./attributes/InvoiceCancelReasonAttributeModule.js";
import InvoiceNonMerchandiseReasonAttributeModule from "./attributes/InvoiceNonMerchandiseReasonAttributeModule.js";
import InvoiceTemplateAttributeModule from "./attributes/InvoiceTemplateAttributeModule.js";
import InvoiceUnApprovalReasonAttributeModule from "./attributes/InvoiceUnApprovalReasonAttributeModule.js";
import LocationAttributeModule from "./attributes/LocationAttributeModule.js";
import LogisticMethodAttributeModule from "./attributes/LogisticMethodModule.js";
import MiscellaneousChargeReasonAttributeModule from "./attributes/MiscellaneousChargeReasonAttributeModule.js";
import PaymentMethodAttributeModule from "./attributes/PaymentMethodAttributeModule.js";
import PaymentTermAttributeModule from "./attributes/PaymentTermAttributeModule.js";
import PeriodSalesCommissionAdjustmentReasonAttributeModule from "./attributes/PeriodSalesCommissionAdjustmentReasonAttributeModule.js";
import PreProductionChangeReasonAttributeModule from "./attributes/PreProductionChangeReasonAttributeModule.js";
import ProductDivisionAttributeModule from "./attributes/ProductDivisionAttributeModule.js";
import ProductStatusAttributeModule from "./attributes/ProductStatusAttributeModule.js";
import PurchaseOrderCancelReasonAttributeModule from "./attributes/PurchaseOrderCancelReasonAttributeModule.js";
import PurchaseOrderModelAttributeModule from "./attributes/PurchaseOrderModelAttributeModule.js";
import PurchaseOrderUnApprovalReasonAttributeModule from "./attributes/PurchaseOrderUnApprovalReasonAttributeModule.js";
import RoyaltyClientAttributeModule from "./attributes/RoyaltyClientAttributeModule.js";
import SeasonAttributeModule from "./attributes/SeasonAttributeModule.js";
import ServiceDetailsAttributeModule from "./attributes/ServiceDetailsAttributeModule.js";
import ShipmentTermAttributeModule from "./attributes/ShipmentTermAttributeModule.js";
import ShipToAttributeModule from "./attributes/ShipToAttributeModule.js";
import ShipViaAttributeModule from "./attributes/ShipViaAttributeModule.js";
import StageCollectionAttributeModule from "./attributes/StageCollectionAttributeModule.js";
import StateAttributeModule from "./attributes/StateAttributeModule.js";
import StyleAttributeModule from "./attributes/StyleAttributeModule.js";
import StyleItemTypeAttributeModule from "./attributes/StyleItemTypeAttributeModule.js";
import StyleTypeAttributeModule from "./attributes/StyleTypeAttributeModule.js";
import TargetWebSiteDetailAttributeModule from "./attributes/TargetWebSiteDetailAttributeModule.js";
import TypeCategoryAttributeModule from "./attributes/TypeCategoryAttributeModule.js";
import UOMAttributeModule from "./attributes/UOMAttributeModule.js";
import VendorCategoryAttributeModule from "./attributes/VendorCategoryAttributeModule.js";
import VendorShipViaAttributeModule from "./attributes/VendorShipViaAttributeModule.js";
import VendorTermAttributeModule from "./attributes/VendorTermAttributeModule.js";
import VendorTypeAttributeModule from "./attributes/VendorTypeAttributeModule.js";
import { ConfigManager } from "./config/ConfigManager.js";
import DashBoardModule from "./gui_components/DashBoard.js";
import ErpIDashBoardModule from "./modules/analytics_dashboard/ErpIDashBoard.js";
import ACHPaymentHistoryInquiry from "./Inquiry/ACHPaymentHistoryInquiry.js";
import AllCustomerOnlineAgingInquiry from "./Inquiry/AllCustomerOnlineAgingInquiry.js";
import AllFabricsCustomerATSInquiry from "./Inquiry/AllFabricsCustomerATSInquiry.js";
import AllFabricsCustomerATSInquiry_v2 from "./Inquiry/AllFabricsCustomerATSInquiry_v2.js";
import ATSInquiry from "./Inquiry/ATSInquiry.js";
import ATSInquiry_v2_job from "./Inquiry/ATSInquiry_v2-job.js";
import ATSInquiry_v2 from "./Inquiry/ATSInquiry_v2.js";
import BankAccountBalanceHistoryInquiry from "./Inquiry/BankAccountBalanceHistoryInquiry.js";
import BinLocationInventoryInquiry from "./Inquiry/BinLocationInventoryInquiry.js";
import BookingReportInquiry from "./Inquiry/BookingReportInquiry.js";
import BouncedCheckInquiry from "./Inquiry/BouncedCheckInquiry.js";
import CardPaymentHistoryInquiry from "./Inquiry/CardPaymentHistoryInquiry.js";
import CashPaymentActivitiesInquiry from "./Inquiry/CashPaymentActivitiesInquiry.js";
import CheckPaymentHistoryInquiry from "./Inquiry/CheckPaymentHistoryInquiry.js";
import CreditMemoPaymentHistoryInquiry from "./Inquiry/CreditMemoPaymentHistoryInquiry.js";
import CustomerAllocationInTransitInfoInquiry from "./Inquiry/CustomerAllocationInTransitInfoInquiry.js";
import CustomerAndFabricSalesInquiry from "./Inquiry/CustomerAndFabricSalesInquiry.js";
import CustomerBalanceInquiry from "./Inquiry/CustomerBalanceInquiry.js";
import CustomerCurrentAgingInquiry from "./Inquiry/CustomerCurrentAgingInquiry.js";
import CustomerFabricsATSInquiry from "./Inquiry/CustomerFabricsATSInquiry.js";
import CustomerFabricsATSInquiry_v2 from "./Inquiry/CustomerFabricsATSInquiry_v2.js";
import CustomerInfoInquiry from "./Inquiry/CustomerInfoInquiry.js";
import CustomerOnOrderInquiry from "./Inquiry/CustomerOnOrderInquiry.js";
import CustomerOnOrderInquiry_v2 from "./Inquiry/CustomerOnOrderInquiry_v2.js";
import CustomerSalesAnalysisInquiry from "./Inquiry/CustomerSalesAnalysisInquiry.js";
import CustomerSalesDetailsInquiry from "./Inquiry/CustomerSalesDetailsInquiry.js";
import CustomerServiceInquiry from "./Inquiry/CustomerServiceInquiry.js";
import CustomerServiceSalesOrderInquiry from "./Inquiry/CustomerServiceSalesOrderInquiry.js";
import CustomerStatisticsInquiry from "./Inquiry/CustomerStatisticsInquiry.js";
import CustomerTransactionInquiry from "./Inquiry/CustomerTransactionInquiry.js";
import FabricInfoInquiry from "./Inquiry/FabricInfoInquiry.js";
import FabricOnOrderInquiry from "./Inquiry/FabricOnOrderInquiry.js";
import FabricStyleInventoryValuationInfoInquiry from "./Inquiry/FabricStyleInventoryValuationInfoInquiry.js";
import FabricStyleInventoryValuationInfoInquiry_v2 from "./Inquiry/FabricStyleInventoryValuationInfoInquiry_v2.js";
import FabricStylePurchaseHistoryInquiry from "./Inquiry/FabricStylePurchaseHistoryInquiry.js";
import FabricStyleSalesInquiry from "./Inquiry/FabricStyleSalesInquiry.js";
import FabricStyleSkuInquiry from "./Inquiry/FabricStyleSkuInquiry.js";
import FabricStyleYearlyInquiry from "./Inquiry/FabricStyleYearlyInquiry.js";
import FabricWeeklyMonthlyATSInquiry from "./Inquiry/FabricWeeklyMonthlyATSInquiry.js";
import FiscalYearBookingInquiry from "./Inquiry/FiscalYearBookingInquiry.js";
import HoldingWareHouseInventoryInquiry from "./Inquiry/HoldingWareHouseInventoryInquiry.js";
import InventoryBinSummaryInquiry from "./Inquiry/InventoryBinSummaryInquiry.js";
import InventoryBinSummaryInquiry_v2 from "./Inquiry/InventoryBinSummaryInquiry_v2.js";
import InvoicedAndNotApprovedListInquiry from "./Inquiry/InvoicedAndNotApprovedListInquiry.js";
import InvoiceRegisterInquiry from "./Inquiry/InvoiceRegisterInquiry.js";
import InvoiceRegisterInquiry_v2 from "./Inquiry/InvoiceRegisterInquiry_v2.js";
import MailTrackInquiry from "./Inquiry/MailTrackInquiry.js";
import ObseleteInventoryInquiry from "./Inquiry/ObseleteInventoryInquiry.js";
import ObseleteInventoryInquiry_V2 from "./Inquiry/ObseleteInventoryInquiry_v2.js";
import OpenPickTicketInquiry from "./Inquiry/OpenPickTicketInquiry.js";
import PastDueInvoiceWithCCPaymentInquiry from "./Inquiry/PastDueInvoiceWithCCPaymentInquiry.js";
import PhysicalVerificationTrackInquiry from "./Inquiry/PhysicalVerificationTrackInquiry.js";
import PickedAndNotInvoicedListInquiry from "./Inquiry/PickedAndNotInvoicedListInquiry.js";
import PickedAndShippedListInquiry from "./Inquiry/PickedAndShippedListInquiry.js";
import PickTicketPickerDetailInquiry from "./Inquiry/PickTicketPickerDetailInquiry.js";
import POInTransitInfoInquiry from "./Inquiry/POInTransitInfoInquiry.js";
import PostDatedCheckDetailInquiry from "./Inquiry/PostDatedCheckDetailInquiry.js";
import PostedAndBouncedCheckInquiry from "./Inquiry/PostedAndBouncedCheckInquiry.js";
import PostedARACHPaymentRegisterInquiry from "./Inquiry/PostedARACHPaymentRegisterInquiry.js";
import PostedARCardPaymentRegisterInquiry from "./Inquiry/PostedARCardPaymentRegisterInquiry.js";
import PostedARCashPaymentRegisterInquiry from "./Inquiry/PostedARCashPaymentRegisterInquiry.js";
import PostedARCheckPaymentRegisterInquiry from "./Inquiry/PostedARCheckPaymentRegisterInquiry.js";
import PostedARDayRegisterInquiry from "./Inquiry/PostedARDayRegisterInquiry.js";
import PostedARWireTransferPaymentRegisterInquiry from "./Inquiry/PostedARWireTransferPaymentRegisterInquiry.js";
import POUnApprovedInfoInquiry from "./Inquiry/POUnApprovedInfoInquiry.js";
import ProductAvailabilityInquiry from "./Inquiry/ProductAvailabilityInquiry.js";
import PurchaseOrderReceiptDetailsInquiry from "./Inquiry/PurchaseOrderReceiptDetailsInquiry.js";
import ReceiptRollBinDetailsInquiry from "./Inquiry/ReceiptRollBinDetailsInquiry.js";
import ReturnSalesPersonCommisionInquiry from "./Inquiry/ReturnSalesPersonCommissionInquiry.js";
import SalesAnalysisInquiry from "./Inquiry/SalesAnalysisInquiry.js";
import SalesBackOrderInquiry from "./Inquiry/SalesBackOrderInquiry.js";
import SalesOrderCancelDetailsInquiry from "./Inquiry/SalesOrderCancelDetailsInquiry.js";
import SalesOrderRegisterDetailsInquiry from "./Inquiry/SalesOrderRegisterDetailsInquiry.js";
import SalesOrderRegisterInquiry from "./Inquiry/SalesOrderRegisterInquiry.js";
import SalesOrderStatusInquiry from "./Inquiry/SalesOrderStatusInquiry.js";
import SalesPersonCommissionInquiry from "./Inquiry/SalesPersonCommissionInquiry.js";
import SalesPersonCurrentAgingInquiry from "./Inquiry/SalesPersonCurrentAgingInquiry.js";
import ShippingReportInquiry from "./Inquiry/ShippingReportInquiry.js";
import SkuBatchInventoryInquiry from "./Inquiry/SkuBatchInventoryInquiry.js";
import SkuBatchInventoryInquiry_v2 from "./Inquiry/SkuBatchInventoryInquiry_v2.js";
import SkuBatchInventoryTrackInquiry from "./Inquiry/SkuBatchInventoryTrackInquiry.js";
import SkuInventoryTrackInquiry from "./Inquiry/SkuInventoryTrackInquiry.js";
import SkuInventoryLotBasedInquiry from "./Inquiry/SkuInventoryLotBasedInquiry.js";
import SkuInventorySkuBasedInquiry from "./Inquiry/SkuInventorySkuBasedInquiry.js";
import SkuInventorySkuBasedInquiry_v2 from "./Inquiry/SkuInventorySkuBasedInquiry_v2.js";
import TestInquiry from "./Inquiry/TestInquiry.js";
import UnpostedARListInquiry from "./Inquiry/UnpostedARListInquiry.js";
import UpsPickupSummaryInquiry from "./Inquiry/UpsPickupSummaryInquiry.js";
import VendorInfoInquiry from "./Inquiry/VendorInfoInquiry.js";
import VendorOnOrderInquiry from "./Inquiry/VendorOnOrderInquiry.js";
import VendorOnOrderInquiry_v2 from "./Inquiry/VendorOnOrderInquiry_v2.js";
import VendorStatisticsInquiry from "./Inquiry/VendorStatisticsInquiry.js";
import WebInventoryInquiry from "./Inquiry/WebInventoryInquiry.js";
import WirePaymentHistoryInquiry from "./Inquiry/WirePaymentHistoryInquiry.js";
import YearlySalesAnalysisInquiry from "./Inquiry/YearlySalesAnalysisInquiry.js";
import SalesYearlyInquiry from "./Inquiry/SalesYearlyInquiry.js";
import AccountReceivableModule from "./modules/AccountReceivableModule.js";
import AdvancedMassSalesOrderPickTicketGeneration from "./modules/AdvancedMassSalesOrderPickTicketGenerationModule.js";
import ApproveInvoiceModule from "./modules/ApproveInvoiceModule.js";
import ApproveSalesOrderModule from "./modules/ApproveSalesOrderModule.js";
import BankAdjustmentModule from "./modules/BankAdjustmentModule.js";
import BatchCheckTransactionModule from "./modules/BatchCheckTransactionModule.js";
import CancelBackOrderModule from "./modules/CancelBackOrderModule.js";
import CheckBounceModule from "./modules/CheckBounceModule.js";
import CheckTransactionModule from "./modules/CheckTransactionModule.js";
import CommercialInvoiceForMultipleInvoice from "./modules/CommercialInvoiceForMultipleInvoiceModule.js";
import CreditMemoModule from "./modules/CreditMemoModule.js";
import CustomerMaintenanceModule from "./modules/CustomerMaintenanceModule.js";
import CustomerReturnModule from "./modules/CustomerReturnModule.js";
import DepositModule from "./modules/DepositModule.js";
import EcomJobStatusModule from "./modules/EcomJobStatusModule.js";
import EcomWebOrderStatusModule from "./modules/EcomWebOrderStatusModule.js";
import FabricStyleCostMaintenanceModule from "./modules/FabricStyleCostMaintenanceModule.js";
import FabricStyleMaintenanceModule from "./modules/FabricStyleMaintenanceModule.js";
import FabricStyleMaintenanceModule_v2 from "./modules/FabricStyleMaintenanceModule_v2.js";

import GenerateInvoiceModule from "./modules/GenerateInvoiceModule.js";
import GeneratePickTicketModule from "./modules/GeneratePickTicketModule.js";
import InventoryAdjustmentModule from "./modules/InventoryAdjustmentModule.js";
import InventoryTransferModule from "./modules/InventoryTransferModule.js";
import InvoiceForMultiplePickTicketModule from "./modules/InvoiceForMultiplePickTicketModule.js";
import InvoiceMaintenanceModule from "./modules/InvoiceMaintenanceModule.js";
import LetterOfCreditModule from "./modules/LetterOfCreditModule.js";
import LogisticOrderModule from "./modules/LogisticOrderModule.js";
import LogisticReceiptModule from "./modules/LogisticReceiptModule.js";
import PalletBarCodeGeneratorModule from "./modules/PalletBarCodeGeneratorModule.js";
import MailInvoicesModule from "./modules/MailInvoicesModule.js";
import ManualInventoryAllocationModule from "./modules/ManualInventoryAllocationModule.js";
import MassCancelPurchaseModule from "./modules/MassCancelPurchaseModule.js";
import MassCancelSalesOrderModule from "./modules/MassCancelSalesOrderModule.js";
import MassInventoryTransferModule from "./modules/MassInventoryTransferModule.js";
import MassPurchaseOrderModule from "./modules/MassPurchaseOrderModule.js";
import MassSalesOrderPickTicketGenerationModule from "./modules/MassSalesOrderPickTicketGenerationModule.js";
import MassSalesOrderPrintModule from "./modules/MassSalesOrderPrintModule.js";
import PhysicalInventoryAdjustmentsModule from "./modules/PhysicalInventoryAdjustmentsModule.js";
import PickTicketMaintenanceModule from "./modules/PickTicketMaintenanceModule.js";
import PickTicketMaintenanceModule_v2 from "./modules/PickTicketMaintenanceModule_v2.js";
import PickTicketRollUtility from "./modules/PickTicketRollUtilityModule.js";
import PostDatedCheckEntryModule from "./modules/PostDatedCheckEntryModule.js";
import PreProductionModule from "./modules/PreProductionMaintenanceModule.js";
import PreProductionModule_v1 from "./modules/PreProductionMaintenanceModule_v1.js";
import PrintBulkPickTicketMaintenance from "./modules/PrintBulkPickTicketMaintenanceModule.js";
import PrintPOInTransitRollModule from "./modules/PrintPOInTransitRollModule.js";
import PrintRollModule from "./modules/PrintRollModule.js";
import PurchaseOrderInTransitModule from "./modules/PurchaseOrderInTransitModule.js";
import PurchaseOrderInTransitModule_v2 from "./modules/PurchaseOrderInTransitModule_v2.js";
import PurchaseOrderModule from "./modules/PurchaseOrderModule.js";
import PurchaseOrderModule_v2 from "./modules/PurchaseOrderModule_v2.js";
import PurchaseOrderReceiptModule from "./modules/PurchaseOrderReceiptModule.js";
import RollDataConversionMaintenanceModule from "./modules/RollDataConversionMaintenanceModule.js";
import RollInventoryModule from "./modules/RollInventoryModule.js";
import SalesCommissionMaintenanceModule from "./modules/SalesCommissionMaintenanceModule.js";
import SalesOrderMaintenanceModule from "./modules/SalesOrderMaintenanceModule.js";
import SalesOrderMaintenanceModule_v2 from "./modules/SalesOrderMaintenanceModule_v2.js";
import RoleMaintenanceModule from "./modules/security/RoleMaintenanceModule.js";
import UserMaintenanceModule from "./modules/security/UserMaintenanceModule.js";
import ReleaseLockModule from "./modules/system/ReleaseLockModule.js";
import VendorInvoiceModule from "./modules/VendorInvoiceModule.js";
import VendorMaintenanceModule from "./modules/VendorMaintenanceModule.js";
import WebItemExcelToERPImportModule from "./modules/WebItemExcelToERPImportModule.js";
import WebItemExportModule from "./modules/WebItemExportModule.js";
import WebItemImportModule from "./modules/WebItemImportModule.js";
import WebSkuInventoryModule from "./modules/WebSkuInventoryExportModule.js";

import InboundOpenOrdersNotReceivedInquiry from "./Inquiry/InboundOpenOrdersNotReceivedInquiry.js";
import InboundReceiptNotInvoicedInquiry from "./Inquiry/InboundReceiptNotInvoicedInquiry.js";

import AllCustomerOnlineAgingInquiry_v3 from "./Inquiry/AllCustomerOnlineAgingInquiry_v3.js";
import ATSInquiry_v3 from "./Inquiry/ATSInquiry_v3.js";
import CustomerCurrentAgingInquiry_v3 from "./Inquiry/CustomerCurrentAgingInquiry_v3.js";
import CustomerOnOrderInquiry_v3 from "./Inquiry/CustomerOnOrderInquiry_v3.js";
import CustomerSalesDetailsInquiry_v3 from "./Inquiry/CustomerSalesDetailsInquiry_v3.js";
import CustomerServiceInquiry_v3 from "./Inquiry/CustomerServiceInquiry_v3.js";
import CustomerServiceSalesOrderInquiry_v3 from "./Inquiry/CustomerServiceSalesOrderInquiry_v3.js";
import FabricStyleInventoryValuationInfoModule_v3 from "./Inquiry/FabricStyleInventoryValuationInfoInquiry_v3.js";
import InvoiceRegisterInquiry_v3 from "./Inquiry/InvoiceRegisterInquiry_v3.js";
import PhysicalVerificationTrackInquiry_v3 from "./Inquiry/PhysicalVerificationTrackInquiry_v3.js";
import SalesOrderRegisterInquiry_v3 from "./Inquiry/SalesOrderRegisterInquiry_v3.js";
import SkuBatchInventoryInquiry_v3 from "./Inquiry/SkuBatchInventoryInquiry_v3.js";
import SkuBatchInventoryTrackInquiry_v3 from "./Inquiry/SkuBatchInventoryTrackInquiry_v3.js";
import SkuInventorySkuBasedInquiry_v3 from "./Inquiry/SkuInventorySkuBasedInquiry_v3.js";
import VendorOnOrderInquiry_v3 from "./Inquiry/VendorOnOrderInquiry_v3.js";
import VendorStatisticsInquiry_v3 from "./Inquiry/VendorStatisticsInquiry_v3.js";
import AccountReceivableModule_v3 from "./modules/AccountReceivableModule_v3.js";
import CheckTransactionModule_v3 from "./modules/CheckTransactionModule_v3.js";
import CreditMemoModule_v3 from "./modules/CreditMemoModule_v3.js";
import CustomerMaintenanceModule_v2 from "./modules/CustomerMaintenanceModule_v2.js";
import CustomerMaintenanceModule_v3 from "./modules/CustomerMaintenanceModule_v3.js";
import FabricStyleMaintenanceModule_v3 from "./modules/FabricStyleMaintenanceModule_v3.js";
import InventoryAdjustmentModule_v3 from "./modules/InventoryAdjustmentModule_v3.js";
import InventoryTransferModule_v3 from "./modules/InventoryTransferModule_v3.js";
import InvoiceMaintenanceModule_v3 from "./modules/InvoiceMaintenanceModule_v3.js";
import PickTicketMaintenanceModule_v3 from "./modules/PickTicketMaintenanceModule_v3.js";
import PurchaseOrderInTransitModule_v3 from "./modules/PurchaseOrderInTransitModule_v3.js";
import PurchaseOrderModule_v3 from "./modules/PurchaseOrderModule_v3.js";
import PurchaseOrderReceiptModule_v3 from "./modules/PurchaseOrderReceiptModule_v3.js";
import SalesCommissionMaintenanceModule_v3 from "./modules/SalesCommissionMaintenanceModule_v3.js";
import SalesOrderMaintenanceModule_v3 from "./modules/SalesOrderMaintenanceModule_v3.js";
import VendorInvoiceModule_v3 from "./modules/VendorInvoiceModule_v3.js";

import CreditMemoDetailsInquiry from "./Inquiry/CreditMemoDetailsInquiry.js";
import CustomerSalesOrderAndInvoiceDetailReportInquiry from "./Inquiry/CustomerSalesOrderAndInvoiceDetailReportInquiry.js";
import CustomerStatementInquiry from "./Inquiry/CustomerStatementInquiry.js";
import FabricStatisticsInquiry from "./Inquiry/FabricStatisticsInquiry.js";
import FabricStylePriceListPriceCostInquiry from "./Inquiry/FabricStylePriceListPriceCostInquiry.js";
import FabricStylesReceivedDetailsInquiry from "./Inquiry/FabricStylesReceivedDetailsInquiry.js";
import InventoryAdjustmentHistoryInquiry from "./Inquiry/InventoryAdjustmentHistoryInquiry.js";
import InvoiceFabricStyleYearlyInquiry from "./Inquiry/InvoiceFabricStyleYearlyInquiry.js";
import LatePurchaseOrderDetailsInquiry from "./Inquiry/LatePurchaseOrderDetailsInquiry.js";
import MostRecentCustomerSalesDetailInquiry from "./Inquiry/MostRecentCustomerSalesDetailInquiry.js";
import PrintOutTrackInquiry from "./Inquiry/PrintOutTrackInquiry.js";
import InvoicePrintoutTypeAttributeModule from "./attributes/InvoicePrintoutTypeAttributeModule.js";
import SalesServiceReportInquiry from "./Inquiry/SalesServiceReportInquiry.js";
import SalesCommodityReportInquiry from "./Inquiry/SalesCommodityReportInquiry.js";
import SalesPriceInquiry from "./Inquiry/SalesPriceInquiry.js";

import RollingInventoryReportInquiry from "./Inquiry/RollingInventoryReportInquiry.js";
import CpmEntryMaintenanceModule from "./modules/CpmEntryMaintenanceModule.js";
import CpmInquiry from "./Inquiry/CpmInquiry.js";

import SalesAndPurchaseDetailsInquiry from "./Inquiry/SalesAndPurchaseDetailsInquiry.js";

import DailyInventoryTrackHistoryInquiry from "./Inquiry/DailyInventoryTrackHistoryInquiry.js";
import DailyInventoryProcessTrackDetailInquiry from "./Inquiry/DailyInventoryProcessTrackDetailInquiry.js";
import LotBasedInventoryInOutInquiry from "./Inquiry/LotBasedInventoryInOutInquiry.js";
import PurchaseOrderSummaryInfoInquiry from "./Inquiry/PurchaseOrderSummaryInfoInquiry.js";
import InvoiceSummaryInfoInquiry from "./Inquiry/InvoiceSummaryInfoInquiry.js";
import SalesOrderSummaryInfoInquiry from "./Inquiry/SalesOrderSummaryInfoInquiry.js";
import PickTicketSummaryInfoInquiry from "./Inquiry/PickTicketSummaryInfoInquiry.js";
import PurchaseOrderReceiptSummaryInfoInquiry from "./Inquiry/PurchaseOrderReceiptSummaryInfoInquiry.js";
import CreditMemoSummaryInfoInquiry from "./Inquiry/CreditMemoSummaryInfoInquiry.js";
import FabricCatalogGeneration from "./Inquiry/FabricCatalogGeneration.js";

import DebitMemoMaintenanceModule from "./modules/DebitMemoMaintenanceModule.js";
import InvoiceModelAttributeModule from "./attributes/InvoiceModelAttributeModule.js";
import FabricStatisticsDetailMaintenance from "./modules/FabricStatisticsDetailMaintenanceModule.js";

export class DisplayModule {
  constructor(key, title, moduleType, moduleObject, entity) {
    this.key = key;
    this.title = title;
    this.moduleType = moduleType;
    this.moduleObject = moduleObject;
    this.reff = "";
  }
  getModuleObject = (moduleId, moduleExitFunction, reference) => {
    const Module = this.moduleObject;
    return (
      <Module
        ref={reference}
        moduleType={this.moduleType}
        moduleId={moduleId}
        onModuleExit={moduleExitFunction}
      />
    );
  };
}

export const AllModuleList = () => {
  let tempModuleList = [];

  let is3PL = false;
  if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
    is3PL = true;
  }
  let customerModule = CustomerMaintenanceModule;
  let customerModule_v2 = CustomerMaintenanceModule_v2;
  let customerModule_v3 = CustomerMaintenanceModule_v3;
  let fabricModule = FabricStyleMaintenanceModule;
  let fabricModule_v2 = FabricStyleMaintenanceModule_v2;
  let fabricModule_v3 = FabricStyleMaintenanceModule_v3;
  let vendorModule = VendorMaintenanceModule;
  let salesOrderModule = SalesOrderMaintenanceModule;
  let salesOrderModule_v2 = SalesOrderMaintenanceModule_v2;
  let salesOrderModule_v3 = SalesOrderMaintenanceModule_v3;
  let massSalesOrderPickTicketGenerationModule =
    MassSalesOrderPickTicketGenerationModule;
  let pickTicketModule = PickTicketMaintenanceModule;
  let pickTicketModule_v2 = PickTicketMaintenanceModule_v2;
  let pickTicketModule_v3 = PickTicketMaintenanceModule_v3;
  let invoiceModule = InvoiceMaintenanceModule;
  let invoiceModule_v3 = InvoiceMaintenanceModule_v3;
  let salesCommissionModule = SalesCommissionMaintenanceModule;
  let salesCommissionModule_v3 = SalesCommissionMaintenanceModule_v3;
  let approveSalesOrderModule = ApproveSalesOrderModule;
  let cancelBackOrderModule = CancelBackOrderModule;
  let massCancelSalesOrderModule = MassCancelSalesOrderModule;
  let generatePickTicketModule = GeneratePickTicketModule;
  let generateInvoiceModule = GenerateInvoiceModule;
  let approveInvoiceModule = ApproveInvoiceModule;
  let purchaseOrderModule = PurchaseOrderModule;
  let purchaseOrderModule_v2 = PurchaseOrderModule_v2;
  let purchaseOrderModule_v3 = PurchaseOrderModule_v3;
  let purchaseOrderReceiptModule = PurchaseOrderReceiptModule;
  let purchaseOrderReceiptModule_v3 = PurchaseOrderReceiptModule_v3;
  let purchaseOrderInTransitModule = PurchaseOrderInTransitModule;
  let purchaseOrderInTransitModule_v2 = PurchaseOrderInTransitModule_v2;
  let purchaseOrderInTransitModule_v3 = PurchaseOrderInTransitModule_v3;
  let massPurchaseOrderModule = MassPurchaseOrderModule;
  let massCancelPurchaseOrderModule = MassCancelPurchaseModule;
  let vendorInvoiceModule = VendorInvoiceModule;
  let vendorInvoiceModule_v3 = VendorInvoiceModule_v3;
  let accountReceivableModule = AccountReceivableModule;
  let accountReceivableModule_v3 = AccountReceivableModule_v3;
  let creditMemoModule = CreditMemoModule;
  let creditMemoModule_v3 = CreditMemoModule_v3;
  let checkTransactionModule = CheckTransactionModule;
  let checkTransactionModule_v3 = CheckTransactionModule_v3;
  let batchCheckTransactionModule = BatchCheckTransactionModule;
  let inventoryAdjustmentModule = InventoryAdjustmentModule;
  let inventoryAdjustmentModule_v3 = InventoryAdjustmentModule_v3;
  let inventoryTransferModule = InventoryTransferModule;
  let inventoryTransferModule_v3 = InventoryTransferModule_v3;
  let printRollModule = PrintRollModule;
  let printPOInTransitRollModule = PrintPOInTransitRollModule;
  let massInventoryTransferModule = MassInventoryTransferModule;
  let physicalInventoryAdjustments = PhysicalInventoryAdjustmentsModule;
  let rollInventoryModule = RollInventoryModule;
  let manualInventoryAllocation = ManualInventoryAllocationModule;
  let rollDataConversion = RollDataConversionMaintenanceModule;
  let webItemExportModule = WebItemExportModule;
  let webItemImportModule = WebItemImportModule;
  let webSkuInventoryModule = WebSkuInventoryModule;
  let ecomJobStatusDetailsModule = EcomJobStatusModule;
  let ecomWebOrderStatusDetailsModule = EcomWebOrderStatusModule;
  let webItemExcelToERPImportModule = WebItemExcelToERPImportModule;
  let currencyAttributeModule = CurrencyAttributeModule;
  let employeeAttributeModule = EmployeeAttributeModule;
  let paymentTermAttributeModule = PaymentTermAttributeModule;
  let uomAttributeModule = UOMAttributeModule;
  let countryAttributeModule = CountryAttributeModule;
  let stateAttributeModule = StateAttributeModule;
  let cityAttributeModule = CityAttributeModule;
  let logisticMethodAttributeModule = LogisticMethodAttributeModule;
  let customerSpecialTypeAttributeModule = CustomerSpecialTypeAttributeModule;
  let customerTypeAttributeModule = CustomerTypeAttributeModule;
  let colorAttributeModule = ColorAttributeModule;
  let seasonAttributeModule = SeasonAttributeModule;
  let commentAttributeModule = CommentAttributeModule;
  let productStatusAttributeModule = ProductStatusAttributeModule;
  let styleItemTypeAttributeModule = StyleItemTypeAttributeModule;
  let bankAccountAttributeModule = BankAccountAttributeModule;
  let productDivisionAttributeModule = ProductDivisionAttributeModule;
  let compositionTypeAttributeModule = CompositionTypeAttributeModule;
  let businessDivisionAttributeModule = BusinessDivisionAttributeModule;
  let styleTypeAttributeModule = StyleTypeAttributeModule;
  let contentAttributeModule = ContentAttributeModule;
  let styleAttributeModule = StyleAttributeModule;
  let typeCategoryAttributeModule = TypeCategoryAttributeModule;
  let currencyExchangeRateAttributeModule = CurrencyExchangeRateAttributeModule;
  let shipToAttributeModule = ShipToAttributeModule;
  let fabricVendorMiscellaneousCostDetailAttributeModule =
    FabricVendorMiscellaneousCostDetailAttributeModule;
  let royaltyClientAttributeModule = RoyaltyClientAttributeModule;
  let fiscalYearAttributeModule = FiscalYearAttributeModule;
  let harmonizedTariffScheduleAttributeModule =
    HarmonizedTariffScheduleAttributeModule;
  let inventoryAdjustmentReasonAttributeModule =
    InventoryAdjustmentReasonAttributeModule;
  let locationAttributeModule = LocationAttributeModule;
  let binLocationAttributeModule = BinLocationAttributeModule;
  let customerDivisionAttributeModule = CustomerDivisionAttributeModule;
  let shipViaAttributeModule = ShipViaAttributeModule;
  let freightMethodAttributeModule = FreightMethodAttributeModule;
  let customerSalesZoneAttributeModule = CustomerSalesZoneAttributeModule;
  let boxTypeAttributeModule = BoxTypeAttributeModule;
  let invoiceTemplateAttributeModule = InvoiceTemplateAttributeModule;
  let paymentMethodAttributeModule = PaymentMethodAttributeModule;
  let customerDeliveryAttributeModule = CustomerDeliveryAttributeModule;
  let invoiceCancelReasonAttributeModule = InvoiceCancelReasonAttributeModule;
  let invoiceUnApprovalReasonAttributeModule =
    InvoiceUnApprovalReasonAttributeModule;
  let invoiceNonMerchandiseReasonAttributeModule =
    InvoiceNonMerchandiseReasonAttributeModule;
  let periodSalesCommissionAdjustmentReasonAttributeModule =
    PeriodSalesCommissionAdjustmentReasonAttributeModule;
  let vendorTypeAttributeModule = VendorTypeAttributeModule;
  let fobCityAttributeModule = FobCityAttributeModule;
  let incoTermAttributeModule = IncoTermAttributeModule;
  let vendorShipViaAttributeModule = VendorShipViaAttributeModule;
  let vendorTermAttributeModule = VendorTermAttributeModule;
  let shipmentTermAttributeModule = ShipmentTermAttributeModule;
  let vendorCategoryAttributeModule = VendorCategoryAttributeModule;
  let purchaseOrderCancelReasonAttributeModule =
    PurchaseOrderCancelReasonAttributeModule;
  let purchaseOrderUnApprovalReasonAttributeModule =
    PurchaseOrderUnApprovalReasonAttributeModule;
  let miscellaneousChargeReasonAttributeModule =
    MiscellaneousChargeReasonAttributeModule;
  let purchaseOrderModelAttributeModule = PurchaseOrderModelAttributeModule;
  let preProductionChangeReasonAttributeModule =
    PreProductionChangeReasonAttributeModule;
  let generalLedgerAccountTypeAttributeModule =
    GeneralLedgerAccountTypeAttributeModule;
  let generalLedgerAccountAttributeModule = GeneralLedgerAccountAttributeModule;
  let accountReceivableDiscountAttributeModule =
    AccountReceivableDiscountDetailReasonAttributeModule;
  let customerTenderReasonAttributeModule = CustomerTenderReasonAttributeModule;
  let customerTenderCancelReasonAttributeModule =
    CustomerTenderCancelReasonAttributeModule;
  let customerTenderUnApprovalReasonAttributeModule =
    CustomerTenderUnApprovalReasonAttributeModule;
  let accountReceivableReversalReasonAttributeModule =
    AccountReceivableReversalReasonAttributeModule;
  let expenseTypeAttributeModule = ExpenseTypeAttributeModule;
  let expenseSubTypeAttributeModule = ExpenseSubTypeAttributeModule;
  let bankAdjustmentReasonAttributeModule = BankAdjustmentReasonAttributeModule;
  let depositCancelReasonAttributeModule = DepositCancelReasonAttributeModule;
  let depositReversalReasonAttributeModule =
    DepositReversalReasonAttributeModule;
  let fabricDetailAttributeModule = FabricDetailAttributeModule;
  let stageCollectionAttributeModule = StageCollectionAttributeModule;
  let targetWebSiteDetailAttributeModule = TargetWebSiteDetailAttributeModule;
  let serviceDetailsAttributeModule = ServiceDetailsAttributeModule;

  let m2 = new DisplayModule(
    "customerMaster",
    "Customer",
    "CustomerModule",
    customerModule
  );
  tempModuleList.push(m2);
  let m2_v2 = new DisplayModule(
    "customerMaster_v2",
    "Customer",
    "CustomerModule",
    customerModule_v2
  );
  tempModuleList.push(m2_v2);
  let m2_v3 = new DisplayModule(
    "customerMaster_v3",
    "Customer",
    "CustomerModule",
    customerModule_v3
  );
  tempModuleList.push(m2_v3);
  let m3 = new DisplayModule(
    "fabricStyleMaster",
    is3PL ? "Item" : "Fabric Style",
    is3PL ? "Item Module" : "Fabric Module",
    fabricModule
  );
  tempModuleList.push(m3);
  let m3_v2 = new DisplayModule(
    "fabricStyleMaster_v2",
    is3PL ? "Item" : "Fabric Style",
    is3PL ? "Item Module" : "Fabric Module",
    fabricModule_v2
  );
  tempModuleList.push(m3_v2);
  let m3_v3 = new DisplayModule(
    "fabricStyleMaster_v3",
    is3PL ? "Item" : "Fabric Style",
    is3PL ? "Item Module" : "Fabric Module",
    fabricModule_v3
  );
  tempModuleList.push(m3_v3);
  let ven_master = new DisplayModule(
    "vendorMaster",
    "Vendor",
    "VendorModule",
    vendorModule
  );
  tempModuleList.push(ven_master);
  let m4 = new DisplayModule(
    "employeeAttribute",
    "Employee",
    "employeeAttributeModule",
    employeeAttributeModule
  );
  tempModuleList.push(m4);
  let m5 = new DisplayModule(
    "paymentTermAttribute",
    "PaymentTerm",
    "paymentTermAttributeModule",
    paymentTermAttributeModule
  );
  tempModuleList.push(m5);
  let m6 = new DisplayModule(
    "uomAttribute",
    "Uom",
    "uomAttributeModule",
    uomAttributeModule
  );
  tempModuleList.push(m6);
  let m7 = new DisplayModule(
    "countryAttribute",
    "Country",
    "countryAttributeModule",
    countryAttributeModule
  );
  tempModuleList.push(m7);
  let m8 = new DisplayModule(
    "stateAttribute",
    "State",
    "stateAttributeModule",
    stateAttributeModule
  );
  tempModuleList.push(m8);
  let m9 = new DisplayModule(
    "cityAttribute",
    "City",
    "cityAttributeModule",
    cityAttributeModule
  );
  tempModuleList.push(m9);
  let logistic = new DisplayModule(
    "logisticMethodAttribute",
    "LogisticMethod",
    "logisticMethodAttributeModule",
    logisticMethodAttributeModule
  );
  tempModuleList.push(logistic);
  let custSplType = new DisplayModule(
    "customerSpecialTypeAttribute",
    "CustomerSpecialType",
    "customerSpecialTypeAttributeModule",
    customerSpecialTypeAttributeModule
  );
  tempModuleList.push(custSplType);
  let custType = new DisplayModule(
    "customerTypeAttribute",
    "PriceType",
    "customerTypeAttributeModule",
    customerTypeAttributeModule
  );
  tempModuleList.push(custType);
  let m10 = new DisplayModule(
    "colorAttribute",
    "Color",
    "colorAttributeModule",
    colorAttributeModule
  );
  tempModuleList.push(m10);
  let m11 = new DisplayModule(
    "seasonAttribute",
    "Season",
    "seasonAttributeModule",
    seasonAttributeModule
  );
  tempModuleList.push(m11);
  let m12 = new DisplayModule(
    "commentAttribute",
    "Comment",
    "commentAttributeModule",
    commentAttributeModule
  );
  tempModuleList.push(m12);
  let m13 = new DisplayModule(
    "productStatusAttribute",
    "ProductStatus",
    "productStatusAttributeModule",
    productStatusAttributeModule
  );
  tempModuleList.push(m13);
  let m14 = new DisplayModule(
    "styleItemTypeAttribute",
    "StyleItemType",
    "styleItemTypeAttributeModule",
    styleItemTypeAttributeModule
  );
  tempModuleList.push(m14);
  let m15 = new DisplayModule(
    "bankAccountAttribute",
    "BankAccount",
    "bankAccountAttributeModule",
    bankAccountAttributeModule
  );
  tempModuleList.push(m15);
  let m16 = new DisplayModule(
    "productDivisionAttribute",
    "ProductDivision",
    "productDivisionAttributeModule",
    productDivisionAttributeModule
  );
  tempModuleList.push(m16);
  let m17 = new DisplayModule(
    "compositionTypeAttribute",
    "CompositionType",
    "compositionTypeAttributeModule",
    compositionTypeAttributeModule
  );
  tempModuleList.push(m17);
  let m18 = new DisplayModule(
    "businessDivisionAttribute",
    "BusinessDivision",
    "businessDivisionAttributeModule",
    businessDivisionAttributeModule
  );
  tempModuleList.push(m18);
  let m19 = new DisplayModule(
    "styleTypeAttribute",
    "StyleType",
    "styleTypeAttributeModule",
    styleTypeAttributeModule
  );
  tempModuleList.push(m19);
  let m20 = new DisplayModule(
    "contentAttribute",
    "Content",
    "contentAttributeModule",
    contentAttributeModule
  );
  tempModuleList.push(m20);
  let m21 = new DisplayModule(
    "styleAttribute",
    "Style",
    "styleAttributeModule",
    styleAttributeModule
  );
  tempModuleList.push(m21);
  let m22 = new DisplayModule(
    "typeCategoryAttribute",
    "TypeCategory",
    "typeCategoryAttributeModule",
    typeCategoryAttributeModule
  );
  tempModuleList.push(m22);
  let m23 = new DisplayModule(
    "currencyExchangeRateAttribute",
    "CurrencyExchangeRate",
    "currencyExchangeRateAttributeModule",
    currencyExchangeRateAttributeModule
  );
  tempModuleList.push(m23);
  let m24 = new DisplayModule(
    "shipToAttribute",
    "ShipTo",
    "shipToAttributeModule",
    shipToAttributeModule
  );
  tempModuleList.push(m24);
  let m25 = new DisplayModule(
    "fabricVendorMiscellaneousCostDetailAttribute",
    "FabricVendorMiscellaneousCostDetail",
    "fabricVendorMiscellaneousCostDetailAttributeModule",
    fabricVendorMiscellaneousCostDetailAttributeModule
  );
  tempModuleList.push(m25);
  let m26 = new DisplayModule(
    "royaltyClientAttribute",
    "RoyaltyClient",
    "royaltyClientAttributeModule",
    royaltyClientAttributeModule
  );
  tempModuleList.push(m26);
  let m27 = new DisplayModule(
    "fiscalYearAttribute",
    "FiscalYear",
    "fiscalYearAttributeModule",
    fiscalYearAttributeModule
  );
  tempModuleList.push(m27);
  let m28 = new DisplayModule(
    "harmonizedTariffScheduleAttribute",
    "HarmonizedTariffSchedule",
    "harmonizedTariffScheduleAttributeModule",
    harmonizedTariffScheduleAttributeModule
  );
  tempModuleList.push(m28);
  let m29 = new DisplayModule(
    "inventoryAdjustmentReasonAttribute",
    "InventoryAdjustmentReason",
    "inventoryAdjustmentReasonAttributeModule",
    inventoryAdjustmentReasonAttributeModule
  );
  tempModuleList.push(m29);
  let m30 = new DisplayModule(
    "locationAttribute",
    "Location",
    "locationAttributeModule",
    locationAttributeModule
  );
  tempModuleList.push(m30);
  let m31 = new DisplayModule(
    "customerDivisionAttribute",
    "Customer",
    "customerDivisionAttributeModule",
    customerDivisionAttributeModule
  );
  tempModuleList.push(m31);
  let m32 = new DisplayModule(
    "binLocation",
    "Bin Location",
    "Bin Location Attribute Module",
    binLocationAttributeModule
  );
  tempModuleList.push(m32);
  let shipVia = new DisplayModule(
    "shipViaAttribute",
    "ShipVia",
    "shipViaAttributeModule",
    shipViaAttributeModule
  );
  tempModuleList.push(shipVia);
  let freightMethod = new DisplayModule(
    "freightMethodAttribute",
    "FreightMethod",
    "freightMethodAttributeModule",
    freightMethodAttributeModule
  );
  tempModuleList.push(freightMethod);
  let custSalesZone = new DisplayModule(
    "customerSalesZoneAttribute",
    "CustomerSalesZone",
    "customerSalesZoneAttributeModule",
    customerSalesZoneAttributeModule
  );
  tempModuleList.push(custSalesZone);
  let boxType = new DisplayModule(
    "boxTypeAttribute",
    "BoxType",
    "boxTypeAttributeModule",
    boxTypeAttributeModule
  );
  tempModuleList.push(boxType);
  let invoiceTemplate = new DisplayModule(
    "invoiceTemplateAttribute",
    "InvoiceTemplate",
    "invoiceTemplateAttributeModule",
    invoiceTemplateAttributeModule
  );
  tempModuleList.push(invoiceTemplate);
  let paymentMethod = new DisplayModule(
    "paymentMethodAttribute",
    "PaymentMethod",
    "paymentMethodAttributeModule",
    paymentMethodAttributeModule
  );
  tempModuleList.push(paymentMethod);
  let custDelivery = new DisplayModule(
    "customerDeliveryAttribute",
    "Delivery Type",
    "customerDeliveryAttributeModule",
    customerDeliveryAttributeModule
  );
  tempModuleList.push(custDelivery);
  let invCancelReason = new DisplayModule(
    "invoiceCancelReasonAttribute",
    "InvoiceCancelReason",
    "invoiceCancelReasonAttributeModule",
    invoiceCancelReasonAttributeModule
  );
  tempModuleList.push(invCancelReason);
  let invUnApprovalReason = new DisplayModule(
    "invoiceUnApprovalReasonAttribute",
    "InvoiceUnApprovalReason",
    "invoiceUnApprovalReasonAttributeModule",
    invoiceUnApprovalReasonAttributeModule
  );
  tempModuleList.push(invUnApprovalReason);
  let invNonMerchandiseReason = new DisplayModule(
    "invoiceNonMerchandiseReasonAttribute",
    "InvoiceNonMerchandiseReason",
    "invoiceNonMerchandiseReasonAttributeModule",
    invoiceNonMerchandiseReasonAttributeModule
  );
  tempModuleList.push(invNonMerchandiseReason);
  let PeriodSalesCommissionAdjustmentReason = new DisplayModule(
    "periodSalesCommissionAdjustmentReasonAttribute",
    "PeriodSalesCommissionAdjustmentReason",
    "periodSalesCommissionAdjustmentReasonAttributeModule",
    periodSalesCommissionAdjustmentReasonAttributeModule
  );
  tempModuleList.push(PeriodSalesCommissionAdjustmentReason);
  let vendorType = new DisplayModule(
    "vendorTypeAttribute",
    "VendorType",
    "vendorTypeAttributeModule",
    vendorTypeAttributeModule
  );
  tempModuleList.push(vendorType);
  let fobCity = new DisplayModule(
    "fobCityAttribute",
    "FobCity",
    "fobCityAttributeModule",
    fobCityAttributeModule
  );
  tempModuleList.push(fobCity);
  let incoTerm = new DisplayModule(
    "incoTermAttribute",
    "IncoTerm",
    "incoTermAttributeModule",
    incoTermAttributeModule
  );
  tempModuleList.push(incoTerm);
  let vendorShipVia = new DisplayModule(
    "vendorShipViaAttribute",
    "VendorShipVia",
    "vendorShipViaAttributeModule",
    vendorShipViaAttributeModule
  );
  tempModuleList.push(vendorShipVia);
  let vendorTerm = new DisplayModule(
    "vendorTermAttribute",
    "VendorTerm",
    "vendorTermAttributeModule",
    vendorTermAttributeModule
  );
  tempModuleList.push(vendorTerm);
  let shipmentTerm = new DisplayModule(
    "shipmentTermAttribute",
    "ShipmentTerm",
    "shipmentTermAttributeModule",
    shipmentTermAttributeModule
  );
  tempModuleList.push(shipmentTerm);
  let vendorCategory = new DisplayModule(
    "vendorCategoryAttribute",
    "VendorCategory",
    "vendorCategoryAttributeModule",
    vendorCategoryAttributeModule
  );
  tempModuleList.push(vendorCategory);

  let purchaseOrderCancelReason = new DisplayModule(
    "purchaseOrderCancelReasonAttribute",
    "PurchaseOrderCancelReason",
    "purchaseOrderCancelReasonAttributeModule",
    purchaseOrderCancelReasonAttributeModule
  );
  tempModuleList.push(purchaseOrderCancelReason);

  let purchaseOrderUnApprovalReason = new DisplayModule(
    "purchaseOrderUnApprovalReasonAttribute",
    "PurchaseOrderUnApprovalReason",
    "purchaseOrderUnApprovalReasonAttributeModule",
    purchaseOrderUnApprovalReasonAttributeModule
  );
  tempModuleList.push(purchaseOrderUnApprovalReason);

  let miscellaneousChargeReason = new DisplayModule(
    "miscellaneousChargeReasonAttribute",
    "MiscellaneousChargeReason",
    "miscellaneousChargeReasonAttributeModule",
    miscellaneousChargeReasonAttributeModule
  );
  tempModuleList.push(miscellaneousChargeReason);

  let purchaseOrderModel = new DisplayModule(
    "purchaseOrderModelAttribute",
    "PurchaseOrderModel",
    "purchaseOrderModelAttributeModule",
    purchaseOrderModelAttributeModule
  );
  tempModuleList.push(purchaseOrderModel);

  let preProductionChangeReason = new DisplayModule(
    "preProductionChangeReasonAttribute",
    "PreProductionChangeReason",
    "preProductionChangeReasonAttributeModule",
    preProductionChangeReasonAttributeModule
  );
  tempModuleList.push(preProductionChangeReason);

  let stageCollection = new DisplayModule(
    "stageCollectionAttribute",
    "StageCollection",
    "stageCollectionAttributeModule",
    stageCollectionAttributeModule
  );
  tempModuleList.push(stageCollection);
  let targetWebSite = new DisplayModule(
    "targetWebSiteDetailAttribute",
    "Target Website Details",
    "targetWebSiteDetailAttributeModule",
    targetWebSiteDetailAttributeModule
  );
  tempModuleList.push(targetWebSite);
  let serviceDetails = new DisplayModule(
    "serviceDetails",
    "serviceDetails",
    "ServiceDetailsAttributeModule",
    serviceDetailsAttributeModule
  );
  tempModuleList.push(serviceDetails);
  let generalLedgerAccountType = new DisplayModule(
    "generalLedgerAccountTypeAttribute",
    "GeneralLedgerAccountType",
    "generalLedgerAccountTypeAttributeModule",
    generalLedgerAccountTypeAttributeModule
  );
  tempModuleList.push(generalLedgerAccountType);

  let generalLedgerAccount = new DisplayModule(
    "generalLedgerAccountAttribute",
    "GeneralLedgerAccount",
    "generalLedgerAccountAttributeModule",
    generalLedgerAccountAttributeModule
  );
  tempModuleList.push(generalLedgerAccount);

  let accountReceivableDiscount = new DisplayModule(
    "accountReceivableDiscountAttribute",
    "AccountReceivableDiscount",
    "accountReceivableDiscountAttributeModule",
    accountReceivableDiscountAttributeModule
  );
  tempModuleList.push(accountReceivableDiscount);

  let custTenderReason = new DisplayModule(
    "customerTenderReasonAttribute",
    "CustomerTenderReason",
    "customerTenderReasonAttributeModule",
    customerTenderReasonAttributeModule
  );
  tempModuleList.push(custTenderReason);

  let custTenderCancelReason = new DisplayModule(
    "customerTenderCancelReasonAttribute",
    "CustomerTenderCancelReason",
    "customerTenderCancelReasonAttributeModule",
    customerTenderCancelReasonAttributeModule
  );
  tempModuleList.push(custTenderCancelReason);

  let custTenderUnApprovalReason = new DisplayModule(
    "customerTenderUnApprovalReasonAttribute",
    "CustomerTenderUnApprovalReason",
    "customerTenderUnApprovalReasonAttributeModule",
    customerTenderUnApprovalReasonAttributeModule
  );
  tempModuleList.push(custTenderUnApprovalReason);

  let accReceivableReversalReason = new DisplayModule(
    "accountReceivableReversalReasonAttribute",
    "AccountReceivableReversalReason",
    "accountReceivableReversalReasonAttributeModule",
    accountReceivableReversalReasonAttributeModule
  );
  tempModuleList.push(accReceivableReversalReason);

  let expenseType = new DisplayModule(
    "expenseTypeAttribute",
    "ExpenseType",
    "expenseTypeAttributeModule",
    expenseTypeAttributeModule
  );
  tempModuleList.push(expenseType);

  let expenseSubType = new DisplayModule(
    "expenseSubTypeAttribute",
    "ExpenseSubType",
    "expenseSubTypeAttributeModule",
    expenseSubTypeAttributeModule
  );
  tempModuleList.push(expenseSubType);

  let bankAdjustmentReason = new DisplayModule(
    "bankAdjustmentReasonAttribute",
    "BankAdjustmentReason",
    "bankAdjustmentReasonAttributeModule",
    bankAdjustmentReasonAttributeModule
  );
  tempModuleList.push(bankAdjustmentReason);

  let depositCancelReason = new DisplayModule(
    "depositCancelReasonAttribute",
    "DepositCancelReason",
    "depositCancelReasonAttributeModule",
    depositCancelReasonAttributeModule
  );
  tempModuleList.push(depositCancelReason);

  let depositReversalReason = new DisplayModule(
    "depositReversalReasonAttribute",
    "DepositReversalReason",
    "depositReversalReasonAttributeModule",
    depositReversalReasonAttributeModule
  );
  tempModuleList.push(depositReversalReason);

  let fabricDetail = new DisplayModule(
    "fabricDetailAttribute",
    is3PL ? "Item Construction" : "Fabric Construction",
    is3PL ? "Fabric Construction Module" : "Fabric Construction Module",
    fabricDetailAttributeModule
  );
  tempModuleList.push(fabricDetail);

  let designDirection = new DisplayModule(
    "designDirectionAttribute",
    "DesignDirection",
    "designDirectionAttributeModule",
    fabricDetailAttributeModule
  );
  tempModuleList.push(designDirection);

  let backed = new DisplayModule(
    "backedAttribute",
    "Backed",
    "backedAttributeModule",
    fabricDetailAttributeModule
  );
  tempModuleList.push(backed);

  let backedTypes = new DisplayModule(
    "backedTypesAttribute",
    "Backed",
    "backedTypesAttributeModule",
    fabricDetailAttributeModule
  );
  tempModuleList.push(backedTypes);

  let boundBackTypes = new DisplayModule(
    "boundBackTypesAttribute",
    "BoundBackTypes",
    "boundBackTypesAttributeModule",
    fabricDetailAttributeModule
  );
  tempModuleList.push(boundBackTypes);

  let cardedOrCombed = new DisplayModule(
    "cardedOrCombedAttribute",
    "CardedOrCombed",
    "cardedOrCombedAttributeModule",
    fabricDetailAttributeModule
  );
  tempModuleList.push(cardedOrCombed);

  let fabricDetails = new DisplayModule(
    "fabricDetailsAttribute",
    is3PL ? "Item Details" : "FabricDetails",
    is3PL ? "Item Details Module" : "FabricDetails Module",
    fabricDetailAttributeModule
  );
  tempModuleList.push(fabricDetails);

  let fillingYarnsTextured = new DisplayModule(
    "fillingYarnsTexturedAttribute",
    "FillingYarnsTextured",
    "fillingYarnsTexturedAttributeModule",
    fabricDetailAttributeModule
  );
  tempModuleList.push(fillingYarnsTextured);

  let fillingYarnsTwisted = new DisplayModule(
    "fillingYarnsTwistedAttribute",
    "FillingYarnsTwisted",
    "fillingYarnsTwistedAttributeModule",
    fabricDetailAttributeModule
  );
  tempModuleList.push(fillingYarnsTwisted);

  let napped = new DisplayModule(
    "nappedAttribute",
    "Napped",
    "nappedAttributeModule",
    fabricDetailAttributeModule
  );
  tempModuleList.push(napped);

  let printed = new DisplayModule(
    "printedAttribute",
    "Printed",
    "printedAttributeModule",
    fabricDetailAttributeModule
  );
  tempModuleList.push(printed);

  let warpYarns = new DisplayModule(
    "warpYarnsAttribute",
    "WarpYarns",
    "warpYarnsAttributeModule",
    fabricDetailAttributeModule
  );
  tempModuleList.push(warpYarns);

  let warpYarnsTextured = new DisplayModule(
    "warpYarnsTexturedAttribute",
    "WarpYarnsTextured",
    "designDirectionAttributeModule",
    fabricDetailAttributeModule
  );
  tempModuleList.push(warpYarnsTextured);

  let warpYarnsTwisted = new DisplayModule(
    "warpYarnsTwistedAttribute",
    "WarpYarnsTwisted",
    "warpYarnsTwistedAttributeModule",
    fabricDetailAttributeModule
  );
  tempModuleList.push(warpYarnsTwisted);

  let washed = new DisplayModule(
    "washedAttribute",
    "Washed",
    "washedAttributeModule",
    fabricDetailAttributeModule
  );
  tempModuleList.push(washed);

  let s1 = new DisplayModule(
    "salesOrder",
    "SalesOrder",
    "SalesOrderMaintenance",
    salesOrderModule
  );
  tempModuleList.push(s1);
  let s1_v2 = new DisplayModule(
    "salesOrder_v2",
    "SalesOrder",
    "SalesOrderMaintenance",
    salesOrderModule_v2
  );
  tempModuleList.push(s1_v2);
  let s1_v3 = new DisplayModule(
    "salesOrder_v3",
    "SalesOrder",
    "SalesOrderMaintenance",
    salesOrderModule_v3
  );
  tempModuleList.push(s1_v3);
  let massSalesOrderPickTicket = new DisplayModule(
    "massSalesOrderPickTicketGeneration",
    "MassSalesOrderPickTicketGenerationModule",
    "MassSalesOrderPickTicketGenerationModule",
    massSalesOrderPickTicketGenerationModule
  );
  tempModuleList.push(massSalesOrderPickTicket);

  let pickTicket = new DisplayModule(
    "pickTicket",
    "PickTicket",
    "PickTicketMaintenance",
    pickTicketModule
  );
  tempModuleList.push(pickTicket);
  let pickTicket_v2 = new DisplayModule(
    "pickTicket_v2",
    "PickTicket",
    "PickTicketMaintenance",
    pickTicketModule_v2
  );
  tempModuleList.push(pickTicket_v2);
  let pickTicket_v3 = new DisplayModule(
    "pickTicket_v3",
    "PickTicket",
    "PickTicketMaintenance",
    pickTicketModule_v3
  );
  tempModuleList.push(pickTicket_v3);
  let inv = new DisplayModule(
    "invoice",
    "Invoice",
    "InvoiceMaintenance",
    invoiceModule
  );
  tempModuleList.push(inv);
  let inv_v3 = new DisplayModule(
    "invoice_v3",
    "Invoice",
    "InvoiceMaintenance",
    invoiceModule_v3
  );
  tempModuleList.push(inv_v3);
  let salesCommission = new DisplayModule(
    "salesCommission",
    "salesCommission",
    "InvoiceMaintenance",
    salesCommissionModule
  );
  tempModuleList.push(salesCommission);

  let salesCommission_v3 = new DisplayModule(
    "salesCommission_v3",
    "salesCommission",
    "InvoiceMaintenance",
    salesCommissionModule_v3
  );
  tempModuleList.push(salesCommission_v3);

  let printBulkPickTicketMaintenance = PrintBulkPickTicketMaintenance;
  let printbulk = new DisplayModule(
    "printBulkPickTicket",
    "Print Bulk PickTicket Maintenance",
    "Print Bulk PickTicket Maintenance",
    printBulkPickTicketMaintenance
  );
  tempModuleList.push(printbulk);

  let massSalesOrderPrint = MassSalesOrderPrintModule;
  let massprint = new DisplayModule(
    "massSalesOrderPrint",
    "Mass SalesOrder Print",
    "Mass SalesOrder Print",
    massSalesOrderPrint
  );
  tempModuleList.push(massprint);

  let pickTicketRollUtility = PickTicketRollUtility;
  let ptRoll = new DisplayModule(
    "ptRollUtility",
    "PickTicket Roll Utility",
    "PickTicket Roll Utility",
    pickTicketRollUtility
  );
  tempModuleList.push(ptRoll);

  let commercialInvoiceForMultipleInvoice = CommercialInvoiceForMultipleInvoice;
  let cominv = new DisplayModule(
    "commercialInvoiceForMultipleInvoice",
    "CommercialInvoice For MultipleInvoice",
    "CommercialInvoice For MultipleInvoice",
    commercialInvoiceForMultipleInvoice
  );
  tempModuleList.push(cominv);

  let advancedSalesOrderPickTicketGeneration =
    AdvancedMassSalesOrderPickTicketGeneration;
  let adv_SO_PT_Generation = new DisplayModule(
    "advancedSalesPickTicketGeneration",
    "Advanced SalesOrder PickTicket Generation",
    "Advanced SalesOrder PickTicket Generation",
    advancedSalesOrderPickTicketGeneration
  );
  tempModuleList.push(adv_SO_PT_Generation);

  let invoiceForMultiplePickTicketModule = InvoiceForMultiplePickTicketModule;
  let invoiceForMultiplePickTicket = new DisplayModule(
    "invoiceForMultiplePickTicket",
    "Invoice For Multiple PickTicket",
    "Invoice For Multiple PickTicket",
    invoiceForMultiplePickTicketModule
  );
  tempModuleList.push(invoiceForMultiplePickTicket);

  let mailInvoicesModule = MailInvoicesModule;
  let mailInvoices = new DisplayModule(
    "mailInvoices",
    "Mail Invoices",
    "Mail Invoices",
    mailInvoicesModule
  );
  tempModuleList.push(mailInvoices);

  let cancelBackOrder = new DisplayModule(
    "cancelBackOrder",
    "Cancel BackOrder",
    "CancelBackOrderModule",
    cancelBackOrderModule
  );
  tempModuleList.push(cancelBackOrder);
  let approveSalesOrder = new DisplayModule(
    "approveSalesOrder",
    "Approve SalesOrder",
    "ApproveSalesOrderModule",
    approveSalesOrderModule
  );
  tempModuleList.push(approveSalesOrder);
  let cancelSalesOrder = new DisplayModule(
    "cancelSalesOrder",
    "Cancel SalesOrder",
    "MassCancelSalesOrderModule",
    massCancelSalesOrderModule
  );
  tempModuleList.push(cancelSalesOrder);
  let generatePickTicket = new DisplayModule(
    "generatePickTicket",
    "Generate PickTicket",
    "GeneratePickTicketModule",
    generatePickTicketModule
  );
  tempModuleList.push(generatePickTicket);
  let generateInvoice = new DisplayModule(
    "generateInvoice",
    "Generate Invoice",
    "GenerateInvoiceModule",
    generateInvoiceModule
  );
  tempModuleList.push(generateInvoice);
  let approveInvoice = new DisplayModule(
    "approveInvoice",
    "Approve Invoice",
    "ApproveInvoiceModule",
    approveInvoiceModule
  );
  tempModuleList.push(approveInvoice);
  let p1 = new DisplayModule(
    "purchaseOrder",
    "PurchaseOrder",
    "PurchaseOrderModule",
    purchaseOrderModule
  );
  tempModuleList.push(p1);
  let p1_v2 = new DisplayModule(
    "purchaseOrder_v2",
    "PurchaseOrder",
    "PurchaseOrderModule",
    purchaseOrderModule_v2
  );
  tempModuleList.push(p1_v2);
  let p1_v3 = new DisplayModule(
    "purchaseOrder_v3",
    "PurchaseOrder",
    "PurchaseOrderModule",
    purchaseOrderModule_v3
  );
  tempModuleList.push(p1_v3);
  let MsPO = new DisplayModule(
    "massPurchaseOrder",
    "MassPurchaseOrderModule",
    "MassPurchaseOrderModule",
    massPurchaseOrderModule
  );
  tempModuleList.push(MsPO);

  let MsPOCancel = new DisplayModule(
    "massCancelPurchase",
    "MassCancelPurchaseModule",
    "MassCancelPurchaseModule",
    massCancelPurchaseOrderModule
  );
  tempModuleList.push(MsPOCancel);

  let p2 = new DisplayModule(
    "purchaseOrderInTransit",
    "PurchaseOrderInTransit",
    "PurchaseOrderInTransitModule",
    purchaseOrderInTransitModule
  );
  tempModuleList.push(p2);
  let p2_v2 = new DisplayModule(
    "purchaseOrderInTransit_v2",
    "PurchaseOrderInTransit",
    "PurchaseOrderInTransitModule",
    purchaseOrderInTransitModule_v2
  );
  tempModuleList.push(p2_v2);

  let p2_v3 = new DisplayModule(
    "purchaseOrderInTransit_v3",
    "PurchaseOrderInTransit",
    "PurchaseOrderInTransitModule",
    purchaseOrderInTransitModule_v3
  );
  tempModuleList.push(p2_v3);

  let p3 = new DisplayModule(
    "purchaseOrderReceipt",
    "PurchaseOrderReceipt",
    "PurchaseOrderReceiptModule",
    purchaseOrderReceiptModule
  );
  tempModuleList.push(p3);

  let p3_v3 = new DisplayModule(
    "purchaseOrderReceipt_v3",
    "PurchaseOrderReceipt",
    "PurchaseOrderReceiptModule",
    purchaseOrderReceiptModule_v3
  );
  tempModuleList.push(p3_v3);

  let p4 = new DisplayModule(
    "vendorInvoice",
    "VendorInvoice",
    "VendorInvoiceModule",
    vendorInvoiceModule
  );
  tempModuleList.push(p4);
  let p4_v3 = new DisplayModule(
    "vendorInvoice_v3",
    "VendorInvoice",
    "VendorInvoiceModule",
    vendorInvoiceModule_v3
  );
  tempModuleList.push(p4_v3);

  let arM = new DisplayModule(
    "accountReceivable",
    "AccountReceivable",
    "AccountReceivableModule",
    accountReceivableModule
  );
  tempModuleList.push(arM);

  let arM_v3 = new DisplayModule(
    "accountReceivable_v3",
    "AccountReceivable",
    "AccountReceivableModule",
    accountReceivableModule_v3
  );
  tempModuleList.push(arM_v3);

  let cm = new DisplayModule(
    "creditMemo",
    "CreditMemo",
    "CreditMemoModule",
    creditMemoModule
  );
  tempModuleList.push(cm);

  let cm_v3 = new DisplayModule(
    "creditMemo_v3",
    "CreditMemo",
    "CreditMemoModule",
    creditMemoModule_v3
  );
  tempModuleList.push(cm_v3);

  let ct = new DisplayModule(
    "checkTransaction",
    "CheckTransaction",
    "CheckTransactionModule",
    checkTransactionModule
  );
  tempModuleList.push(ct);

  let ct_v3 = new DisplayModule(
    "checkTransaction_v3",
    "CheckTransaction",
    "CheckTransactionModule",
    checkTransactionModule_v3
  );
  tempModuleList.push(ct_v3);

  let bct = new DisplayModule(
    "batchCheckTransaction",
    "BatchCheckTransaction",
    "BatchCheckTransactionModule",
    batchCheckTransactionModule
  );
  tempModuleList.push(bct);

  let bankAdjustmentModule = BankAdjustmentModule;
  let ba = new DisplayModule(
    "bankAdjustment",
    "BankAdjustmentModule",
    "BankAdjustmentModule",
    bankAdjustmentModule
  );
  tempModuleList.push(ba);

  let depositModule = DepositModule;
  let deposit = new DisplayModule(
    "deposit",
    "DepositModule",
    "DepositModule",
    depositModule
  );
  tempModuleList.push(deposit);
  let letterOfCreditModule = LetterOfCreditModule;
  let loc = new DisplayModule(
    "letterOfCredits",
    "LetterOfCreditModule",
    "LetterOfCreditModule",
    letterOfCreditModule
  );
  tempModuleList.push(loc);

  let checkBounceModule = CheckBounceModule;
  let checkBounce = new DisplayModule(
    "checkBounce",
    "CheckBounceModule",
    "CheckBounceModule",
    checkBounceModule
  );
  tempModuleList.push(checkBounce);
  let customerReturnModule = CustomerReturnModule;
  let customerReturn = new DisplayModule(
    "customerReturn",
    "CustomerReturnModule",
    "CustomerReturnModule",
    customerReturnModule
  );
  tempModuleList.push(customerReturn);
  let i1 = new DisplayModule(
    "inventoryAdjustment",
    "InventoryAdjustment",
    "InventoryAdjustmentModule",
    inventoryAdjustmentModule
  );
  tempModuleList.push(i1);

  let i1_v3 = new DisplayModule(
    "inventoryAdjustment_v3",
    "InventoryAdjustment",
    "InventoryAdjustmentModule",
    inventoryAdjustmentModule_v3
  );
  tempModuleList.push(i1_v3);

  let i2 = new DisplayModule(
    "inventoryTransfer",
    "InventoryTransfer",
    "InventoryTransferModule",
    inventoryTransferModule
  );
  tempModuleList.push(i2);

  let i2_v3 = new DisplayModule(
    "inventoryTransfer_v3",
    "InventoryTransfer",
    "InventoryTransferModule",
    inventoryTransferModule_v3
  );
  tempModuleList.push(i2_v3);

  let i3 = new DisplayModule(
    "printRoll",
    "Print Roll",
    "PrintRollModule",
    printRollModule
  );
  tempModuleList.push(i3);

  let i4 = new DisplayModule(
    "printPOInTransitRoll",
    "Print PO InTransit Roll",
    "PrintPOInTransitRollModule",
    printPOInTransitRollModule
  );
  tempModuleList.push(i4);
  let i5 = new DisplayModule(
    "massInventoryTransfer",
    "Mass Inventory Transfer",
    "MassInventoryTransferModule",
    massInventoryTransferModule
  );
  tempModuleList.push(i5);
  let i6 = new DisplayModule(
    "physicalInvAdjustments",
    "Physical Inventory Adjustments",
    "Physical Inventory Adjustments",
    physicalInventoryAdjustments
  );
  tempModuleList.push(i6);
  let i7 = new DisplayModule(
    "rollInventory",
    "Roll Inventory",
    "Roll Inventory",
    rollInventoryModule
  );
  tempModuleList.push(i7);
  let i8 = new DisplayModule(
    "manualInvAllocation",
    "Manual Inventory Allocation",
    "Manual Inventory Allocation",
    manualInventoryAllocation
  );
  tempModuleList.push(i8);
  let i48 = new DisplayModule(
    "rollDataConversion",
    "Roll Data Conversion",
    "Roll Data Conversion",
    rollDataConversion
  );
  tempModuleList.push(i48);

  let webItemExport = new DisplayModule(
    "webItemExport",
    "Web Item Export",
    "WebItemExportModule",
    webItemExportModule
  );
  tempModuleList.push(webItemExport);

  let webItemImport = new DisplayModule(
    "webItemImport",
    "Web Item Import",
    "webItemImportModule",
    webItemImportModule
  );
  tempModuleList.push(webItemImport);

  let webSkuInventoryExport = new DisplayModule(
    "webSkuInventoryExport",
    "Web Sku Inventory Export",
    "WebSkuInventoryModule",
    webSkuInventoryModule
  );
  tempModuleList.push(webSkuInventoryExport);

  let ecomJobStatusDetails = new DisplayModule(
    "ecomJobStatusDetails",
    "Ecom Job Status Details",
    "EcomJobStatusModule",
    ecomJobStatusDetailsModule
  );
  tempModuleList.push(ecomJobStatusDetails);

  let ecomWebOrderStatusDetails = new DisplayModule(
    "ecomWebOrderStatusDetails",
    "Ecom Web Order Status Details",
    "EcomWebOrderStatusModule",
    ecomWebOrderStatusDetailsModule
  );
  tempModuleList.push(ecomWebOrderStatusDetails);
  let webItemExcelToERP = new DisplayModule(
    "webItemExcelToERP",
    "Web Item Excel to ERP Import",
    "Web Item Excel to ERP Import",
    webItemExcelToERPImportModule
  );
  tempModuleList.push(webItemExcelToERP);

  let a1 = new DisplayModule(
    "currencyAttribute",
    "Currency",
    "CurrencyAttributeModule",
    currencyAttributeModule
  );
  tempModuleList.push(a1);

  let a2 = new DisplayModule(
    "employeeAttribute",
    "Employee",
    "employeeAttributeModule",
    employeeAttributeModule
  );
  tempModuleList.push(a2);

  let a3 = new DisplayModule(
    "paymentTermAttribute",
    "PaymentTerm",
    "paymentTermAttributeModule",
    paymentTermAttributeModule
  );
  tempModuleList.push(a3);

  let a4 = new DisplayModule(
    "uomAttribute",
    "Uom",
    "uomAttributeModule",
    uomAttributeModule
  );
  tempModuleList.push(a4);

  let a5 = new DisplayModule(
    "stateAttribute",
    "State",
    "stateAttributeModule",
    stateAttributeModule
  );
  tempModuleList.push(a5);

  let a6 = new DisplayModule(
    "cityAttribute",
    "City",
    "cityAttributeModule",
    cityAttributeModule
  );
  tempModuleList.push(a6);

  let atsInquiryModule = ATSInquiry;
  let I1 = new DisplayModule(
    "fabricAts",
    is3PL ? "All Item ATS" : "All Fabric ATS",
    is3PL ? "All Item ATS" : "All Fabric ATS",
    atsInquiryModule
  );
  tempModuleList.push(I1);
  let atsInquiryModule_v2 = ATSInquiry_v2;
  let I1_v2 = new DisplayModule(
    "fabricAts_v2",
    "All Fabric ATS",
    "ATS Inquiry",
    atsInquiryModule_v2
  );
  tempModuleList.push(I1_v2);
  let atsInquiryModule_v3 = ATSInquiry_v3;
  let I1_v3 = new DisplayModule(
    "fabricAts_v3",
    "All Fabric ATS",
    "ATS Inquiry",
    atsInquiryModule_v3
  );
  tempModuleList.push(I1_v3);
  let atsInquiryModule_v2_job = ATSInquiry_v2_job;
  let I1_v2_job = new DisplayModule(
    "fabricAts_v2_job",
    "All Fabric ATS",
    "ATS Inquiry",
    atsInquiryModule_v2_job
  );
  tempModuleList.push(I1_v2_job);
  let allCustomerATSInquiry = AllFabricsCustomerATSInquiry;
  let allCustomerAts = new DisplayModule(
    "allCustomerAts",
    is3PL ? "All Item Customer ATS" : "All Fabrics Customer ATS",
    is3PL
      ? "All Item Customer ATS Inquiry"
      : "All Fabrics Customer ATS Inquiry",
    allCustomerATSInquiry
  );
  tempModuleList.push(allCustomerAts);
  let allCustomerATSInquiry_v2 = AllFabricsCustomerATSInquiry_v2;
  let allCustomerAts_v2 = new DisplayModule(
    "allCustomerAts_v2",
    is3PL ? "All Item Customer ATS" : "All Fabrics Customer ATS",
    is3PL
      ? "All Item Customer ATS Inquiry"
      : "All Fabrics Customer ATS Inquiry",
    allCustomerATSInquiry_v2
  );
  tempModuleList.push(allCustomerAts_v2);
  let customerATSInquiry = CustomerFabricsATSInquiry;
  let customerAts = new DisplayModule(
    "customerAts",
    is3PL ? "Customer Item ATS" : "Customer Fabric ATS",
    is3PL ? "Customer Item ATS Inquiry" : "Customer Fabric ATS Inquiry",
    customerATSInquiry
  );
  tempModuleList.push(customerAts);
  let customerATSInquiry_v2 = CustomerFabricsATSInquiry_v2;
  let customerAts_v2 = new DisplayModule(
    "customerAts_v2",
    "Customer Fabric ATS",
    "Customer Fabric ATS Inquiry",
    customerATSInquiry_v2
  );
  tempModuleList.push(customerAts_v2);
  let mailTrackInquiry = MailTrackInquiry;
  let mailTrack = new DisplayModule(
    "mailTrack",
    "Mail Track",
    "Mail Track Inquiry",
    mailTrackInquiry
  );
  tempModuleList.push(mailTrack);
  let WeeklyMonthlyATSInquiry = FabricWeeklyMonthlyATSInquiry;
  let FabricWeeklyMonthly = new DisplayModule(
    "FabricWeeklyMonthly",
    is3PL
      ? "Item  Weekly Monthly ATS Inquiry"
      : "Fabric Weekly Monthly ATS Inquiry",
    is3PL
      ? "Item Weekly Monthly ATS Inquiry Module"
      : "Fabric Weekly Monthly ATS Inquiry Module",
    WeeklyMonthlyATSInquiry
  );
  tempModuleList.push(FabricWeeklyMonthly);

  let customerOnOrderInquiryModule = CustomerOnOrderInquiry;
  let I2 = new DisplayModule(
    "customerOnOrder",
    "CustomerOnOrder",
    "CustomerOnOrderInquiry",
    customerOnOrderInquiryModule
  );
  tempModuleList.push(I2);
  let customerOnOrderInquiry_v2 = CustomerOnOrderInquiry_v2;
  let customerOnOrder_v2 = new DisplayModule(
    "customerOnOrder_v2",
    "customerOnOrder_v2",
    "Customer OnOrder Inquiry",
    customerOnOrderInquiry_v2
  );
  tempModuleList.push(customerOnOrder_v2);
  let customerOnOrderInquiry_v3 = CustomerOnOrderInquiry_v3;
  let customerOnOrder_v3 = new DisplayModule(
    "customerOnOrder_v3",
    "customerOnOrder",
    "Customer OnOrder Inquiry",
    customerOnOrderInquiry_v3
  );
  tempModuleList.push(customerOnOrder_v3);

  let customerSalesDetailsInquiryModule = CustomerSalesDetailsInquiry;
  let I3 = new DisplayModule(
    "customerSalesDetails",
    "CustomerSalesDetails",
    "CustomerSalesDetailsInquiry",
    customerSalesDetailsInquiryModule
  );
  tempModuleList.push(I3);

  let customerSalesDetailsInquiry_v3 = CustomerSalesDetailsInquiry_v3;
  let I3_v3 = new DisplayModule(
    "customerSalesDetails_v3",
    "CustomerSalesDetails",
    "CustomerSalesDetailsInquiry",
    customerSalesDetailsInquiry_v3
  );
  tempModuleList.push(I3_v3);

  let invoiceRegisterInquiryModule = InvoiceRegisterInquiry;
  let I4 = new DisplayModule(
    "invoiceRegister",
    "InvoiceRegister",
    "InvoiceRegisterInquiry",
    invoiceRegisterInquiryModule
  );
  tempModuleList.push(I4);
  let invoiceRegisterInquiry = InvoiceRegisterInquiry_v2;
  let invoiceRegister_v2 = new DisplayModule(
    "invoiceRegister_v2",
    "Invoice Register",
    "Invoice Register Inquiry",
    invoiceRegisterInquiry
  );
  tempModuleList.push(invoiceRegister_v2);
  let invoiceRegisterInquiry_v3 = InvoiceRegisterInquiry_v3;
  let invoiceRegister_v3 = new DisplayModule(
    "invoiceRegister_v3",
    "Invoice Register",
    "Invoice Register Inquiry",
    invoiceRegisterInquiry_v3
  );
  tempModuleList.push(invoiceRegister_v3);
  let salesOrderRegisterInquiryModule = SalesOrderRegisterInquiry;
  let salesOrderRegister = new DisplayModule(
    "salesOrderRegister",
    "SalesOrderRegister",
    "SalesOrderRegisterInquiry",
    salesOrderRegisterInquiryModule
  );
  tempModuleList.push(salesOrderRegister);

  let salesOrderRegisterInquiryModule_v3 = SalesOrderRegisterInquiry_v3;
  let salesOrderRegister_v3 = new DisplayModule(
    "salesOrderRegister_v3",
    "SalesOrderRegister",
    "SalesOrderRegisterInquiry",
    salesOrderRegisterInquiryModule_v3
  );
  tempModuleList.push(salesOrderRegister_v3);
  let salesBackOrderInquiry = SalesBackOrderInquiry;
  let salesBackOrder = new DisplayModule(
    "salesBackOrder",
    "SalesBackOrder",
    "SalesBackOrderInquiry",
    salesBackOrderInquiry
  );
  tempModuleList.push(salesBackOrder);
  let customerServiceInquiry = CustomerServiceInquiry;
  let customerService = new DisplayModule(
    "customerService",
    "CustomerService",
    "CustomerService Inquiry",
    customerServiceInquiry
  );
  tempModuleList.push(customerService);
  let customerServiceInquiry_v3 = CustomerServiceInquiry_v3;
  let customerService_v3 = new DisplayModule(
    "customerService_v3",
    "CustomerService",
    "CustomerService Inquiry",
    customerServiceInquiry_v3
  );
  tempModuleList.push(customerService_v3);
  let pickedAndNotInvoicedListInquiry = PickedAndNotInvoicedListInquiry;
  let pickedAndNotInvoiced = new DisplayModule(
    "pickedAndNotInvoiced",
    "picked And NotInvoiced List",
    "picked And NotInvoiced List Inquiry",
    pickedAndNotInvoicedListInquiry
  );
  tempModuleList.push(pickedAndNotInvoiced);
  let invoicedAndNotApprovedListInquiry = InvoicedAndNotApprovedListInquiry;
  let invoicedAndNotApproved = new DisplayModule(
    "invoicedAndNotApproved",
    "Invoiced And NotApproved List",
    "Invoiced And NotApproved List Inquiry",
    invoicedAndNotApprovedListInquiry
  );
  tempModuleList.push(invoicedAndNotApproved);
  let upsPickupSummaryInquiry = UpsPickupSummaryInquiry;
  let upsPickupSummary = new DisplayModule(
    "upsPickupSummary",
    "UPS Pickup Summary",
    "UPS Pickup Summary Inquiry",
    upsPickupSummaryInquiry
  );
  tempModuleList.push(upsPickupSummary);
  let openPickTicketInquiry = OpenPickTicketInquiry;
  let openPickTicket = new DisplayModule(
    "openPickTicket",
    "open PickTicket",
    "Open PickTicket",
    openPickTicketInquiry
  );
  tempModuleList.push(openPickTicket);
  let pickTicketPickerDetailInquiry = PickTicketPickerDetailInquiry;
  let PickTicketPicker = new DisplayModule(
    "PickTicketPicker",
    "PickTicket Picker",
    "PickTicketr Picker Detail",
    pickTicketPickerDetailInquiry
  );
  tempModuleList.push(PickTicketPicker);
  let pickedAndShippedListInquiry = PickedAndShippedListInquiry;
  let pickedAndShippedList = new DisplayModule(
    "pickedAndShippedList",
    "Picket And Shipped List",
    "Picket And Shipped List Inquiry",
    pickedAndShippedListInquiry
  );
  tempModuleList.push(pickedAndShippedList);
  let salesOrderRegisterDetailsInquiry = SalesOrderRegisterDetailsInquiry;
  let salesOrderRegisterDetails = new DisplayModule(
    "salesOrderRegisterDetails",
    "salesOrder Register Details",
    "salesOrder Register Details",
    salesOrderRegisterDetailsInquiry
  );
  tempModuleList.push(salesOrderRegisterDetails);
  let salesOrderCancelDetailsInquiry = SalesOrderCancelDetailsInquiry;
  let salesOrderCancelDetails = new DisplayModule(
    "salesOrderCancelDetails",
    "SalesOrder Cancel Details",
    "SalesOrder Cancel Details",
    salesOrderCancelDetailsInquiry
  );
  tempModuleList.push(salesOrderCancelDetails);
  let bookingReportInquiry = BookingReportInquiry;
  let bookingReport = new DisplayModule(
    "bookingReport",
    "Booking Report",
    "Booking Report Inquiry",
    bookingReportInquiry
  );
  tempModuleList.push(bookingReport);
  let shippingReportInquiry = ShippingReportInquiry;
  let shippingReport = new DisplayModule(
    "shippingReport",
    "Shipping Report",
    "Shipping Report Inquiry",
    shippingReportInquiry
  );
  tempModuleList.push(shippingReport);
  let salesPersonCommissionInquiry = SalesPersonCommissionInquiry;
  let salesPersonCommision = new DisplayModule(
    "salesPersonCommision",
    "SalesPerson Commission",
    "SalesPerson Commission",
    salesPersonCommissionInquiry
  );
  tempModuleList.push(salesPersonCommision);
  let returnSalesPersonCommisionInquiry = ReturnSalesPersonCommisionInquiry;
  let returnSalesPersonCommision = new DisplayModule(
    "returnSalesPersonCommision",
    "return SalesPerson Commision",
    "return SalesPerson Commision Inquiry",
    returnSalesPersonCommisionInquiry
  );
  tempModuleList.push(returnSalesPersonCommision);
  let customerAndFabricSalesInquiry = CustomerAndFabricSalesInquiry;
  let customerAndFabricSales = new DisplayModule(
    "customerAndFabricSales",
    is3PL ? "Customer And Item Sales" : "Customer And Fabric Sales",
    is3PL ? "Customer And Item Sales" : "Customer And Fabric Sales",
    customerAndFabricSalesInquiry
  );
  tempModuleList.push(customerAndFabricSales);

  let customerBalanceInquiryModule = CustomerBalanceInquiry;
  let I7 = new DisplayModule(
    "customerBalance",
    "CustomerBalance",
    "CustomerBalanceInquiry",
    customerBalanceInquiryModule
  );
  tempModuleList.push(I7);

  let bankBalanceInquiryModule = BankAccountBalanceHistoryInquiry;
  let I8 = new DisplayModule(
    "bankBalance",
    "BankBalance",
    "BankAccountBalanceInquiry",
    bankBalanceInquiryModule
  );
  tempModuleList.push(I8);

  let pastDueInvoiceInquiryModule = PastDueInvoiceWithCCPaymentInquiry;
  let I9 = new DisplayModule(
    "pastDueInvoice",
    "PastDueInvoiceWithCCPayment",
    "PastDueInvoiceWithCCPayment",
    pastDueInvoiceInquiryModule
  );
  tempModuleList.push(I9);

  let postedARDayRegisterInquiryModule = PostedARDayRegisterInquiry;
  let I10 = new DisplayModule(
    "postedARDayRegister",
    "PostedARDayRegisterInquiry",
    "PostedARDayRegisterInquiry",
    postedARDayRegisterInquiryModule
  );
  tempModuleList.push(I10);

  let postedAndBouncedCheckInquiryModule = PostedAndBouncedCheckInquiry;
  let I11 = new DisplayModule(
    "postedAndBouncedCheck",
    "PostedAndBouncedCheckInquiry",
    "PostedAndBouncedCheckInquiry",
    postedAndBouncedCheckInquiryModule
  );
  tempModuleList.push(I11);

  let postedARCashPaymentRegisterInquiryModule =
    PostedARCashPaymentRegisterInquiry;
  let I12 = new DisplayModule(
    "postedARCashPaymentRegister",
    "PostedARCashPaymentRegisterInquiry",
    "PostedARCashPaymentRegisterInquiry",
    postedARCashPaymentRegisterInquiryModule
  );
  tempModuleList.push(I12);

  let postedARCardPaymentRegisterInquiryModule =
    PostedARCardPaymentRegisterInquiry;
  let I13 = new DisplayModule(
    "postedARCardPaymentRegister",
    "PostedARCardPaymentRegisterInquiry",
    "PostedARCardPaymentRegisterInquiry",
    postedARCardPaymentRegisterInquiryModule
  );
  tempModuleList.push(I13);

  let postedARWireTransferPaymentRegisterInquiryModule =
    PostedARWireTransferPaymentRegisterInquiry;
  let I14 = new DisplayModule(
    "postedARWireTransferPaymentRegister",
    "PostedARWireTransferPaymentRegisterInquiry",
    "PostedARWireTransferPaymentRegisterInquiry",
    postedARWireTransferPaymentRegisterInquiryModule
  );
  tempModuleList.push(I14);

  let postedARCheckPaymentRegisterInquiryModule =
    PostedARCheckPaymentRegisterInquiry;
  let I17 = new DisplayModule(
    "postedARCheckPaymentRegister",
    "PostedARCheckPaymentRegisterInquiry",
    "PostedARCheckPaymentRegisterInquiry",
    postedARCheckPaymentRegisterInquiryModule
  );
  tempModuleList.push(I17);

  let checkPaymentHistoryInquiryModule = CheckPaymentHistoryInquiry;
  let I18 = new DisplayModule(
    "checkPaymentHistory",
    "CheckPaymentHistoryInquiry",
    "CheckPaymentHistoryInquiry",
    checkPaymentHistoryInquiryModule
  );
  tempModuleList.push(I18);

  let cardPaymentHistoryInquiryModule = CardPaymentHistoryInquiry;
  let I19 = new DisplayModule(
    "cardPaymentHistory",
    "CardPaymentHistoryInquiry",
    "CardPaymentHistoryInquiry",
    cardPaymentHistoryInquiryModule
  );
  tempModuleList.push(I19);

  let postedARACHPaymentRegisterInquiryModule =
    PostedARACHPaymentRegisterInquiry;
  let I20 = new DisplayModule(
    "postedARACHPaymentRegister",
    "PostedARACHPaymentRegisterInquiry",
    "PostedARACHPaymentRegisterInquiry",
    postedARACHPaymentRegisterInquiryModule
  );
  tempModuleList.push(I20);

  let achPaymentHistoryInquiryModule = ACHPaymentHistoryInquiry;
  let I21 = new DisplayModule(
    "achPaymentHistory",
    "ACHPaymentHistoryInquiry",
    "ACHPaymentHistoryInquiry",
    achPaymentHistoryInquiryModule
  );
  tempModuleList.push(I21);

  let wirePaymentHistoryInquiryModule = WirePaymentHistoryInquiry;
  let I22 = new DisplayModule(
    "wirePaymentHistory",
    "WirePaymentHistoryInquiry",
    "WirePaymentHistoryInquiry",
    wirePaymentHistoryInquiryModule
  );
  tempModuleList.push(I22);

  let bouncedCheckInquiryModule = BouncedCheckInquiry;
  let I23 = new DisplayModule(
    "bouncedCheck",
    "BouncedCheckInquiry",
    "BouncedCheckInquiry",
    bouncedCheckInquiryModule
  );
  tempModuleList.push(I23);

  let unPostedARListInquiryModule = UnpostedARListInquiry;
  let I24 = new DisplayModule(
    "unPostedARList",
    "UnPostedARListInquiry",
    "UnPostedARListInquiry",
    unPostedARListInquiryModule
  );
  tempModuleList.push(I24);

  let creditMemoPaymentHistoryInquiryModule = CreditMemoPaymentHistoryInquiry;
  let I25 = new DisplayModule(
    "creditMemoPaymentHistory",
    "CreditMemoPaymentHistoryInquiry",
    "CreditMemoPaymentHistorytInquiry",
    creditMemoPaymentHistoryInquiryModule
  );
  tempModuleList.push(I25);
  let cashPaymentActivitiesInquiry = CashPaymentActivitiesInquiry;
  let CashPaymentActivities = new DisplayModule(
    "CashPaymentActivities",
    "Cash Payment Activities",
    "Cash Payment Activities",
    cashPaymentActivitiesInquiry
  );
  tempModuleList.push(CashPaymentActivities);
  let postDatedCheckDetailInquiry = PostDatedCheckDetailInquiry;
  let postDatedCheckDetail = new DisplayModule(
    "postDatedCheckDetail",
    "post Dated Check Detail",
    "post Dated Check Detail",
    postDatedCheckDetailInquiry
  );
  tempModuleList.push(postDatedCheckDetail);
  let customerTransactionInquiryModule = CustomerTransactionInquiry;
  let I26 = new DisplayModule(
    "customerTransaction",
    "CustomerTransactionInquiry",
    "CustomerTransactionInquiry",
    customerTransactionInquiryModule
  );
  tempModuleList.push(I26);

  let salesPersonCurrentAgingInquiryModule = SalesPersonCurrentAgingInquiry;
  let I27 = new DisplayModule(
    "salesPersonCurrentAging",
    "SalesPersonCurrentAgingInquiry",
    "SalesPersonCurrentAgingInquiry",
    salesPersonCurrentAgingInquiryModule
  );
  tempModuleList.push(I27);
  let webInventoryInquiryModule = WebInventoryInquiry;
  let webInventory = new DisplayModule(
    "webInventory",
    "web Inventory",
    "web Inventory Inquiry",
    webInventoryInquiryModule
  );
  tempModuleList.push(webInventory);
  let inventoryBinSummaryInquiry = InventoryBinSummaryInquiry;
  let inventoryBinSummary = new DisplayModule(
    "inventoryBinSummary",
    "Inventory Bin Summary",
    "Inventory Bin Summary",
    inventoryBinSummaryInquiry
  );
  tempModuleList.push(inventoryBinSummary);
  let inventoryBinSummaryInquiry_v2 = InventoryBinSummaryInquiry_v2;
  let inventoryBinSummary_v2 = new DisplayModule(
    "inventoryBinSummary_v2",
    "Inventory Bin Summary",
    "Inventory Bin Summary",
    inventoryBinSummaryInquiry_v2
  );
  tempModuleList.push(inventoryBinSummary_v2);
  let skuInventoryLotBasedInquiry = SkuInventoryLotBasedInquiry;
  let skuInventoryLotBased = new DisplayModule(
    "skuInventoryLotBased",
    "sku Inventory LotBased",
    "SkuInventory Lot Based",
    skuInventoryLotBasedInquiry
  );
  tempModuleList.push(skuInventoryLotBased);
  let physicalVerificationTrackInquiry = PhysicalVerificationTrackInquiry;
  let physicalVerificationTrack = new DisplayModule(
    "physicalVerificationTrack",
    "physical Verification Track",
    "Physical Verification Track",
    physicalVerificationTrackInquiry
  );
  tempModuleList.push(physicalVerificationTrack);

  let physicalVerificationTrackInquiry_v3 = PhysicalVerificationTrackInquiry_v3;
  let physicalVerificationTrack_v3 = new DisplayModule(
    "physicalVerificationTrack_v3",
    "physical Verification Track",
    "Physical Verification Track",
    physicalVerificationTrackInquiry_v3
  );
  tempModuleList.push(physicalVerificationTrack_v3);
  let holdingWareHouseInventoryInquiry = HoldingWareHouseInventoryInquiry;
  let holdingWarehouseInventory = new DisplayModule(
    "holdingWarehouseInventory",
    "holding Warehouse Inventory",
    "holding Warehouse Inventory",
    holdingWareHouseInventoryInquiry
  );
  tempModuleList.push(holdingWarehouseInventory);
  let fabricStyleInventoryValuationInfoInquiry =
    FabricStyleInventoryValuationInfoInquiry;
  let fabricStyleInventoryValuation = new DisplayModule(
    "fabricStyleInventoryValuation",
    is3PL
      ? "Item InventoryValuationInfo"
      : "FabricStyle InventoryValuationInfo",
    is3PL
      ? "Item InventoryValuationInfo"
      : "FabricStyle InventoryValuationInfo",
    fabricStyleInventoryValuationInfoInquiry
  );
  tempModuleList.push(fabricStyleInventoryValuation);
  let fabricStyleInventoryValuationInfoInquiry_v2 =
    FabricStyleInventoryValuationInfoInquiry_v2;
  let fabricStyleInventoryValuation_v2 = new DisplayModule(
    "fabricStyleInventoryValuation_v2",
    is3PL
      ? "Item InventoryValuationInfo"
      : "FabricStyle InventoryValuationInfo",
    is3PL
      ? "Item InventoryValuationInfo"
      : "FabricStyle InventoryValuationInfo",
    fabricStyleInventoryValuationInfoInquiry_v2
  );
  tempModuleList.push(fabricStyleInventoryValuation_v2);

  let fabricStyleInventoryValuationInfoInquiry_v3 =
    FabricStyleInventoryValuationInfoModule_v3;
  let fabricStyleInventoryValuation_v3 = new DisplayModule(
    "fabricStyleInventoryValuation_v3",
    is3PL
      ? "Item InventoryValuationInfo"
      : "FabricStyle InventoryValuationInfo",
    is3PL
      ? "Item InventoryValuationInfo"
      : "FabricStyle InventoryValuationInfo",
    fabricStyleInventoryValuationInfoInquiry_v3
  );
  tempModuleList.push(fabricStyleInventoryValuation_v3);
  let customerAllocationInTransitInfoInquiry =
    CustomerAllocationInTransitInfoInquiry;
  let customerAllocationIntransitInfo = new DisplayModule(
    "customerAllocationIntransitInfo",
    "Customer Allocation InTransitInfo",
    "CustomerAllocationInTransitInfoInquiry",
    customerAllocationInTransitInfoInquiry
  );
  tempModuleList.push(customerAllocationIntransitInfo);
  let skuBatchInventoryInquiryModule = SkuBatchInventoryInquiry;
  let I28 = new DisplayModule(
    "skuBatchInventory",
    "SkuBatchInventoryInquiry",
    "SkuBatchInventoryInquiry",
    skuBatchInventoryInquiryModule
  );
  tempModuleList.push(I28);

  let skuBatchInventoryInquiryModule_v2 = SkuBatchInventoryInquiry_v2;
  let skuBatchInventory_v2 = new DisplayModule(
    "skuBatchInventory_v2",
    "SKU BatchInventory Inquiry",
    "SKU BatchInventory Inquiry",
    skuBatchInventoryInquiryModule_v2
  );
  tempModuleList.push(skuBatchInventory_v2);

  let skuBatchInventoryInquiryModule_v3 = SkuBatchInventoryInquiry_v3;
  let skuBatchInventory_v3 = new DisplayModule(
    "skuBatchInventory_v3",
    "SKU BatchInventory Inquiry",
    "SKU BatchInventory Inquiry",
    skuBatchInventoryInquiryModule_v3
  );
  tempModuleList.push(skuBatchInventory_v3);

  let skuBatchInventoryTrackInquiryModule = SkuBatchInventoryTrackInquiry;
  let I29 = new DisplayModule(
    "skuBatchInventoryTrack",
    "SkuBatchInventoryTrackInquiry",
    "SkuBatchInventoryTrackInquiry",
    skuBatchInventoryTrackInquiryModule
  );
  tempModuleList.push(I29);

  let skuInventoryTrackInquiryModule = SkuInventoryTrackInquiry;
  let I49 = new DisplayModule(
    "skuInventoryTrack",
    "SkuInventoryTrackInquiry",
    "SkuInventoryTrackInquiry",
    skuInventoryTrackInquiryModule
  );
  tempModuleList.push(I49);

  let skuBatchInventoryTrackInquiryModule_v3 = SkuBatchInventoryTrackInquiry_v3;
  let I29_v3 = new DisplayModule(
    "skuBatchInventoryTrack_v3",
    "SkuBatchInventoryTrackInquiry",
    "SkuBatchInventoryTrackInquiry",
    skuBatchInventoryTrackInquiryModule_v3
  );
  tempModuleList.push(I29_v3);
  let binLocationInventoryInquiryModule = BinLocationInventoryInquiry;
  let I30 = new DisplayModule(
    "binInventory",
    "BinLocationInventoryInquiry",
    "BinLocationInventoryInquiry",
    binLocationInventoryInquiryModule
  );
  tempModuleList.push(I30);
  let skuInventorySkuBasedInquiry = SkuInventorySkuBasedInquiry;
  let skuInventory = new DisplayModule(
    "skuInventory",
    "Sku Inventory",
    "SKU Inventory SKU Based",
    skuInventorySkuBasedInquiry
  );
  tempModuleList.push(skuInventory);
  let obseleteInventoryInquiry = ObseleteInventoryInquiry;
  let obseleteInventory = new DisplayModule(
    "obseleteInventory",
    "Obselete Inventory",
    "obselete Inventory",
    obseleteInventoryInquiry
  );
  tempModuleList.push(obseleteInventory);
  let skuInventorySkuBasedInquiry_v2 = SkuInventorySkuBasedInquiry_v2;
  let skuInventory_v2 = new DisplayModule(
    "skuInventory_v2",
    "Sku Inventory",
    "SKU Inventory SKU Based",
    skuInventorySkuBasedInquiry_v2
  );
  tempModuleList.push(skuInventory_v2);

  let skuInventorySkuBasedInquiry_v3 = SkuInventorySkuBasedInquiry_v3;
  let skuInventory_v3 = new DisplayModule(
    "skuInventory_v3",
    "Sku Inventory",
    "SKU Inventory SKU Based",
    skuInventorySkuBasedInquiry_v3
  );
  tempModuleList.push(skuInventory_v3);

  let obseleteInventoryInquiry_v2 = ObseleteInventoryInquiry_V2;
  let obseleteInventory_v2 = new DisplayModule(
    "obseleteInventory_v2",
    "Obselete Inventory",
    "obselete Inventory",
    obseleteInventoryInquiry_v2
  );
  tempModuleList.push(obseleteInventory_v2);
  let fabricInfoInquiryModule = FabricInfoInquiry;
  let I31 = new DisplayModule(
    "fabricInfo",
    is3PL ? "ItemInfoInquiry" : "FabricInfoInquiry",
    is3PL ? "ItemInfoInquiry" : "FabricInfoInquiry",
    fabricInfoInquiryModule
  );
  tempModuleList.push(I31);

  let customerInfoInquiryModule = CustomerInfoInquiry;
  let I32 = new DisplayModule(
    "customerInfo",
    "CustomerInfoInquiry",
    "CustomerInfoInquiry",
    customerInfoInquiryModule
  );
  tempModuleList.push(I32);

  let vendorInfoInquiryModule = VendorInfoInquiry;
  let I33 = new DisplayModule(
    "vendorInfo",
    "VendorInfoInquiry",
    "VendorInfoInquiry",
    vendorInfoInquiryModule
  );
  tempModuleList.push(I33);
  let productAvailabilityInquiryModule = ProductAvailabilityInquiry;
  let I34 = new DisplayModule(
    "productAvailability",
    "ProductAvailabilityInquiry",
    "ProductAvailabilityInquiry",
    productAvailabilityInquiryModule
  );
  tempModuleList.push(I34);
  let fabricStyleSalesInquiry = FabricStyleSalesInquiry;
  let fabricStyleSales = new DisplayModule(
    "fabricStyleSales",
    is3PL ? "Item Sales Inquiry" : "FabricStyle Sales Inquiry",
    is3PL ? "Item Sales Inquiry" : "FabricStyle Sales Inquiry",
    fabricStyleSalesInquiry
  );
  tempModuleList.push(fabricStyleSales);
  let salesOrderStatusInquiry = SalesOrderStatusInquiry;
  let salesOrderStatus = new DisplayModule(
    "salesOrderStatus",
    "salesOrder Status",
    "SalesOrder Status Inquiry",
    salesOrderStatusInquiry
  );
  tempModuleList.push(salesOrderStatus);
  let salesAnalysisInquiry = SalesAnalysisInquiry;
  let salesAnalysis = new DisplayModule(
    "salesAnalysis",
    "Sales Analysis",
    "Sales Analysis Inquiry",
    salesAnalysisInquiry
  );
  tempModuleList.push(salesAnalysis);
  let customerSalesAnalysisInquiry = CustomerSalesAnalysisInquiry;
  let customerSalesAnalysis = new DisplayModule(
    "customerSalesAnalysis",
    "Customer Sales Analysis",
    "Customer Sales Analysis Inquiry",
    customerSalesAnalysisInquiry
  );
  tempModuleList.push(customerSalesAnalysis);
  let fiscalYearBookingInquiry = FiscalYearBookingInquiry;
  let fiscalYearBooking = new DisplayModule(
    "fiscalYearBooking",
    "fiscal Year Booking",
    "Fiscal Year Booking Inquiry",
    fiscalYearBookingInquiry
  );
  tempModuleList.push(fiscalYearBooking);
  let fabricStyleYearlyInquiry = FabricStyleYearlyInquiry;
  let fabricStyleYearly = new DisplayModule(
    "fabricStyleYearly",
    is3PL ? "Item Yearly Inquiry" : "FabricStyle Yearly Inquiry",
    is3PL ? "Item Yearly Inquiry Module" : "FabricStyle Yearly Inquiry Module",
    fabricStyleYearlyInquiry
  );
  tempModuleList.push(fabricStyleYearly);
  let yearlySalesAnalysisInquiryModule = YearlySalesAnalysisInquiry;
  let I35 = new DisplayModule(
    "yearlySalesAnalysis",
    "YearlySalesAnalysisInquiry",
    "YearlySalesAnalysisInquiry",
    yearlySalesAnalysisInquiryModule
  );
  tempModuleList.push(I35);
  let customerStatisticsInquiryModule = CustomerStatisticsInquiry;
  let I36 = new DisplayModule(
    "customerStatistics",
    "CustomerStatisticsInquiry",
    "CustomerStatisticsInquiry",
    customerStatisticsInquiryModule
  );
  tempModuleList.push(I36);

  let vendorStatisticsInquiryModule = VendorStatisticsInquiry;
  let I37 = new DisplayModule(
    "vendorStatistics",
    "VendorStatisticsInquiry",
    "VendorStatisticsInquiry",
    vendorStatisticsInquiryModule
  );
  tempModuleList.push(I37);

  let vendorStatisticsInquiryModule_v3 = VendorStatisticsInquiry_v3;
  let I37_v3 = new DisplayModule(
    "vendorStatistics_v3",
    "VendorStatisticsInquiry",
    "VendorStatisticsInquiry",
    vendorStatisticsInquiryModule_v3
  );
  tempModuleList.push(I37_v3);

  let poUnApprovedInfoInquiryModule = POUnApprovedInfoInquiry;
  let I38 = new DisplayModule(
    "poUnApprovedInfo",
    "POUnApprovedInfoInquiry",
    "POUnApprovedInfoInquiry",
    poUnApprovedInfoInquiryModule
  );
  tempModuleList.push(I38);

  let fabricStylePurchaseHistoryInquiryModule =
    FabricStylePurchaseHistoryInquiry;
  let I39 = new DisplayModule(
    "fabricStylePurchaseHistory",
    is3PL
      ? "Item Purchase History Inquiry"
      : "FabricStyle Purchase History Inquiry",
    is3PL
      ? "Item Purchase History Inquiry Module"
      : "FabricStyle Purchase History Inquiry Module",
    fabricStylePurchaseHistoryInquiryModule
  );
  tempModuleList.push(I39);

  let poInTransitInfoInquiryModule = POInTransitInfoInquiry;
  let I40 = new DisplayModule(
    "poInTransitInfo",
    "POInTransitInfoInquiry",
    "POInTransitInfoInquiry",
    poInTransitInfoInquiryModule
  );
  tempModuleList.push(I40);

  let poReceiptDetailsInquiryModule = PurchaseOrderReceiptDetailsInquiry;
  let I41 = new DisplayModule(
    "poReceiptDetails",
    "PurchaseOrderReceiptDetailsInquiry",
    "PurchaseOrderReceiptDetailsInquiry",
    poReceiptDetailsInquiryModule
  );
  tempModuleList.push(I41);

  let receiptRollBinDetailsInquiryModule = ReceiptRollBinDetailsInquiry;
  let I42 = new DisplayModule(
    "receiptRollBinDetails",
    "ReceiptRollBinDetailsInquiry",
    "ReceiptRollBinDetailsInquiry",
    receiptRollBinDetailsInquiryModule
  );
  tempModuleList.push(I42);

  let fabricOnOrderInquiryModule = FabricOnOrderInquiry;
  let I43 = new DisplayModule(
    "fabricOnOrder",
    is3PL ? "ItemOnOrder" : "FabricOnOrder",
    is3PL ? "ItemOnOrderInquiry" : "FabricOnOrderInquiry",
    fabricOnOrderInquiryModule
  );
  tempModuleList.push(I43);
  let customerServiceSOInquiry = CustomerServiceSalesOrderInquiry;
  let custServiceSO = new DisplayModule(
    "custServiceSO",
    "Customer Service SO",
    "CustomerService SO Inquiry",
    customerServiceSOInquiry
  );
  tempModuleList.push(custServiceSO);

  let customerServiceSOInquiry_v3 = CustomerServiceSalesOrderInquiry_v3;
  let custServiceSO_v3 = new DisplayModule(
    "custServiceSO_v3",
    "Customer Service SO",
    "CustomerService SO Inquiry",
    customerServiceSOInquiry_v3
  );
  tempModuleList.push(custServiceSO_v3);

  let vendorOnOrderInquiryModule = VendorOnOrderInquiry;
  let I44 = new DisplayModule(
    "vendorOnOrder",
    "VendorOnOrderInquiry",
    "VendorOnOrderInquiry",
    vendorOnOrderInquiryModule
  );
  tempModuleList.push(I44);
  let vendorOnOrderInquiry_v2 = VendorOnOrderInquiry_v2;
  let vendorOnOrder_v2 = new DisplayModule(
    "vendorOnOrder_v2",
    "VendorOnOrderInquiry",
    "Vendor OnOrder Inquiry",
    vendorOnOrderInquiry_v2
  );
  tempModuleList.push(vendorOnOrder_v2);
  let vendorOnOrderInquiry_v3 = VendorOnOrderInquiry_v3;
  let vendorOnOrder_v3 = new DisplayModule(
    "vendorOnOrder_v3",
    "VendorOnOrderInquiry",
    "Vendor OnOrder Inquiry",
    vendorOnOrderInquiry_v3
  );
  tempModuleList.push(vendorOnOrder_v3);

  let customerCurrentAgingInquiryModule = CustomerCurrentAgingInquiry;
  let I45 = new DisplayModule(
    "customerAging",
    "CustomerCurrentAging",
    "CustomerCurrentAgingInquiry",
    customerCurrentAgingInquiryModule
  );
  tempModuleList.push(I45);

  let customerCurrentAgingInquiryModule_v3 = CustomerCurrentAgingInquiry_v3;
  let I45_v3 = new DisplayModule(
    "customerAging_v3",
    "CustomerCurrentAging",
    "CustomerCurrentAgingInquiry",
    customerCurrentAgingInquiryModule_v3
  );
  tempModuleList.push(I45_v3);

  let allCustomerOnlineAgingInquiryModule = AllCustomerOnlineAgingInquiry;
  let I46 = new DisplayModule(
    "allCustomerOnlineAging",
    "AllCustomerOnlineAgingInquiry",
    "AllCustomerOnlineAgingInquiry",
    allCustomerOnlineAgingInquiryModule
  );
  tempModuleList.push(I46);

  let allCustomerOnlineAgingInquiryModule_v3 = AllCustomerOnlineAgingInquiry_v3;
  let I46_v3 = new DisplayModule(
    "allCustomerOnlineAging_v3",
    "AllCustomerOnlineAgingInquiry",
    "AllCustomerOnlineAgingInquiry",
    allCustomerOnlineAgingInquiryModule_v3
  );
  tempModuleList.push(I46_v3);

  let fabricStyleSkuInquiryModule = FabricStyleSkuInquiry;
  let I47 = new DisplayModule(
    "fabricStyleSKUDetails",
    is3PL ? "Item Sku Inquiry" : "FabricStyleSkuInquiry",
    is3PL ? "Item Sku Inquiry Module" : "FabricStyleSkuInquiry Module",
    fabricStyleSkuInquiryModule
  );
  tempModuleList.push(I47);

  let userMaintenanceModule = UserMaintenanceModule;
  let SE1 = new DisplayModule(
    "userMaintenance",
    "UserMaintenanceModule",
    "UserMaintenanceModule",
    userMaintenanceModule
  );
  tempModuleList.push(SE1);

  let roleMaintenanceModule = RoleMaintenanceModule;
  let SE2 = new DisplayModule(
    "roleMaintenance",
    "RoleMaintenanceModule",
    "RoleMaintenanceModule",
    roleMaintenanceModule
  );
  tempModuleList.push(SE2);

  let releaseLockModule = ReleaseLockModule;
  let rl = new DisplayModule(
    "releaseLock",
    "ReleaseLockModule",
    "ReleaseLockModule",
    releaseLockModule
  );
  tempModuleList.push(rl);

  let testInquiry = TestInquiry;
  let test = new DisplayModule(
    "test",
    "Test Inquiry",
    "Test Inquiry",
    testInquiry
  );
  tempModuleList.push(test);

  let preProductionModule = PreProductionModule;

  let cpm = new DisplayModule(
    "cpm",
    "Development CPM",
    "Development CPM",
    preProductionModule
  );
  tempModuleList.push(cpm);

  let preProductionModule_v1 = PreProductionModule_v1;

  let preProduction = new DisplayModule(
    "preProduction",
    "PreProduction Maintenance",
    "PreProduction Maintenance",
    preProductionModule_v1
  );
  tempModuleList.push(preProduction);

  let logisticOrderModule = LogisticOrderModule;

  let logesticOrder = new DisplayModule(
    "logesticOrder",
    "InBound Order",
    "InBound Order",
    logisticOrderModule
  );
  tempModuleList.push(logesticOrder);

  let logisticReceiptModule = LogisticReceiptModule;

  let logesticReceipt = new DisplayModule(
    "logesticReceipt",
    "InBound Receipt",
    "InBound Receipt",
    logisticReceiptModule
  );
  tempModuleList.push(logesticReceipt);

  let palletBarCodeGeneratorModule = PalletBarCodeGeneratorModule;
  let palletBarCodeGenerator = new DisplayModule(
    "palletBarCodeGenerator",
    "Pallet BarCode Generator",
    "Pallet BarCode Generator",
    palletBarCodeGeneratorModule
  );
  tempModuleList.push(palletBarCodeGenerator);

  let dashBoardModule = DashBoardModule;

  let dashBoard = new DisplayModule(
    "dashBoard",
    "DashBoard",
    "DashBoard",
    dashBoardModule
  );
  tempModuleList.push(dashBoard);

  let erpIdashBoardModule = ErpIDashBoardModule;

  let erpIdashBoard = new DisplayModule(
    "erp-I-dashBoard",
    "ERP-EYE-DashBoard",
    "ERP-I-DashBoard",
    erpIdashBoardModule
  );
  tempModuleList.push(erpIdashBoard);

  let fabricStyleCostModule = FabricStyleCostMaintenanceModule;

  let fabricStyleCost = new DisplayModule(
    "fabricStyleCostMaster",
    is3PL ? "ItemCost" : "FabricStyleCost",
    is3PL ? "ItemCost" : "FabricStyleCost",
    fabricStyleCostModule
  );
  tempModuleList.push(fabricStyleCost);

  let postDatedCheckEntryModule = PostDatedCheckEntryModule;

  let postDatedCheck = new DisplayModule(
    "postDatedCheckEntry",
    "Post Dated Check Entry",
    "Post Dated Check Entry",
    postDatedCheckEntryModule
  );
  tempModuleList.push(postDatedCheck);
  let inboundOpenOrdersNotReceivedInquiry = InboundOpenOrdersNotReceivedInquiry;
  let inboundOpenOrderNotReceived = new DisplayModule(
    "inboundOpenOrderNotReceived",
    "InBound OpenOrder Not Received",
    "InBound OpenOrder Not Received",
    inboundOpenOrdersNotReceivedInquiry
  );
  tempModuleList.push(inboundOpenOrderNotReceived);
  let inboundReceiptNotInvoicedInquiry = InboundReceiptNotInvoicedInquiry;
  let inboundReceiptNotInvoiced = new DisplayModule(
    "inboundReceiptNotInvoiced",
    "InBound Receipt Not Invoiced",
    "InBound Receipt Not Invoiced",
    inboundReceiptNotInvoicedInquiry
  );
  tempModuleList.push(inboundReceiptNotInvoiced);

  let creditMemoDetailsInquiry = CreditMemoDetailsInquiry;
  let cr7 = new DisplayModule(
    "creditMemoDetailsInquiry",
    "CreditMemoDetailsInquiry",
    "CreditMemoDetailsInquiry",
    creditMemoDetailsInquiry
  );
  tempModuleList.push(cr7);

  let printOutTrackInquiry = PrintOutTrackInquiry;
  let ff7 = new DisplayModule(
    "printOutTrackInquiry",
    "PrintOutTrackInquiry",
    "PrintOutTrackInquiry",
    printOutTrackInquiry
  );
  tempModuleList.push(ff7);

  let customerSalesOrderAndInvoiceDetailReportInquiry =
    CustomerSalesOrderAndInvoiceDetailReportInquiry;
  let cs98 = new DisplayModule(
    "customerSalesOrderAndInvoiceDetailReportInquiry",
    "CustomerSalesOrderAndInvoiceDetailReport",
    "CustomerSalesOrderAndInvoiceDetailReport",
    customerSalesOrderAndInvoiceDetailReportInquiry
  );
  tempModuleList.push(cs98);

  let fabricStylePriceListPriceCostInquiry =
    FabricStylePriceListPriceCostInquiry;
  let FPC45 = new DisplayModule(
    "fabricStylePriceListPriceCostInquiry",
    is3PL
      ? "ItemPriceListPriceCostInquiry"
      : "FabricStylePriceListPriceCostInquiry",
    is3PL
      ? "ItemPriceListPriceCostInquiry"
      : "FabricStylePriceListPriceCostInquiry",
    fabricStylePriceListPriceCostInquiry
  );
  tempModuleList.push(FPC45);

  let mostRecentCustomerSalesDetailInquiry =
    MostRecentCustomerSalesDetailInquiry;
  let MRC78 = new DisplayModule(
    "mostRecentCustomerSalesDetailInquiry",
    "MostRecentCustomerSalesDetailInquiry",
    "MostRecentCustomerSalesDetailInquiry",
    mostRecentCustomerSalesDetailInquiry
  );
  tempModuleList.push(MRC78);

  let fabricStatisticsInquiryModule = FabricStatisticsInquiry;
  let fabricStatistics = new DisplayModule(
    "fabricStatistics",
    is3PL ? "Item Statistics Inquiry" : "Fabric Statistics Inquiry",
    is3PL ? "Item Statistics Inquiry" : "Fabric Statistics Inquiry",
    fabricStatisticsInquiryModule
  );
  tempModuleList.push(fabricStatistics);
  let inventoryAdjustmentHistoryInquiry = InventoryAdjustmentHistoryInquiry;
  let inventoryAdjustmentHistory = new DisplayModule(
    "inventoryAdjustmentHistory",
    "InventoryAdjustment History",
    "Inventory Adjustment History",
    inventoryAdjustmentHistoryInquiry
  );
  tempModuleList.push(inventoryAdjustmentHistory);
  let invoiceFabricStyleYearlyInquiry = InvoiceFabricStyleYearlyInquiry;
  let invoiceFabricStyleYearly = new DisplayModule(
    "invoiceFabricStyleYearly",
    is3PL ? "Invoice Item YearlyInquiry" : "Invoice FabricStyle YearlyInquiry",
    is3PL ? "Invoice Item Yearly" : "Invoice FabricStyle Yearly",
    invoiceFabricStyleYearlyInquiry
  );
  tempModuleList.push(invoiceFabricStyleYearly);
  let latePurchaseOrderDetailsInquiry = LatePurchaseOrderDetailsInquiry;
  let latePurchaseOrderDetails = new DisplayModule(
    "latePurchaseOrderDetails",
    "Late PurchaseOrder Details",
    "Late PurchaseOrder Details",
    latePurchaseOrderDetailsInquiry
  );
  tempModuleList.push(latePurchaseOrderDetails);
  let fabricStylesReceivedDetailsInquiry = FabricStylesReceivedDetailsInquiry;
  let FabricStylesReceivedDetails = new DisplayModule(
    "fabricStylesReceivedDetails",
    is3PL ? "Items Received Details" : "FabricStyles Received Details",
    is3PL ? "Items Received Details" : "FabricStyles Received Details",
    fabricStylesReceivedDetailsInquiry
  );
  tempModuleList.push(FabricStylesReceivedDetails);
  let customerStatementInquiry = CustomerStatementInquiry;
  let CustomerStatement = new DisplayModule(
    "customerStatement",
    "Customer Statement",
    "Customer Statement",
    customerStatementInquiry
  );
  tempModuleList.push(CustomerStatement);

  let invoicePrintoutType = InvoicePrintoutTypeAttributeModule;
  let invoicePrintout = new DisplayModule(
    "invoicePrintoutType",
    "Invoice Printout",
    "Invoice Printout",
    invoicePrintoutType
  );
  tempModuleList.push(invoicePrintout);

  let salesServiceReport = SalesServiceReportInquiry;
  let salesServiceDetails = new DisplayModule(
    "salesServiceDetails",
    "SalesServiceReportDetails",
    "SalesServiceReportDetails",
    salesServiceReport
  );
  tempModuleList.push(salesServiceDetails);

  let salesCommodityReport = SalesCommodityReportInquiry;
  let salesCommodityDetails = new DisplayModule(
    "salesCommodityDetails",
    "SalesCommodityDetails",
    "SalesCommodityDetails",
    salesCommodityReport
  );
  tempModuleList.push(salesCommodityDetails);

  const salesPriceInquiry = SalesPriceInquiry;
  const salesPrice = new DisplayModule(
    "salesPrice",
    "Sales Price Inquiry ",
    "Sales Price Inquiry",
    salesPriceInquiry
  );
  tempModuleList.push(salesPrice);

  let rollingInventoryReport = RollingInventoryReportInquiry;
  let rollingInventoryReportDetails = new DisplayModule(
    "rollingInventoryReport",
    "RollingInventoryReportDetails",
    "RollingInventoryReportDetails",
    rollingInventoryReport
  );
  tempModuleList.push(rollingInventoryReportDetails);

  let cpmEntryMaintenance = CpmEntryMaintenanceModule;
  let cpmEntry = new DisplayModule(
    "cpmEntry",
    "CPM Entry Maintenance",
    "CPM Entry Maintenance",
    cpmEntryMaintenance
  );
  tempModuleList.push(cpmEntry);

  let cpmReportInquiry = CpmInquiry;
  let cpmInquiry = new DisplayModule(
    "cpmInq",
    "CPM Report",
    "CPM Report",
    cpmReportInquiry
  );
  tempModuleList.push(cpmInquiry);

  let dailyInventoryTrackReport = DailyInventoryTrackHistoryInquiry;
  let dailyInventoryDetails = new DisplayModule(
    "dailyInventorys",
    "DailyInventoryTrackHistory",
    "DailyInventoryTrackHistoryInquiry",
    dailyInventoryTrackReport
  );
  tempModuleList.push(dailyInventoryDetails);

  let dailyInventoryProcessTrackReport =
    DailyInventoryProcessTrackDetailInquiry;
  let dailyInventoryProcessTrackDetail = new DisplayModule(
    "dailyInventoryProcess",
    "DailyInventoryProcessTrackDetail",
    "DailyInventoryProcessTrackDetailInquiry",
    dailyInventoryProcessTrackReport
  );
  tempModuleList.push(dailyInventoryProcessTrackDetail);

  let salesAndPurchaseDetailsInquiry = SalesAndPurchaseDetailsInquiry;
  let salesAndPurchaseDetailsInq = new DisplayModule(
    "salesAndPurchaseInq",
    "Sales & Purchase Details Inquiry",
    "Sales & Purchase Details Inquiry",
    salesAndPurchaseDetailsInquiry
  );
  tempModuleList.push(salesAndPurchaseDetailsInq);

  let lotBasedInventory = LotBasedInventoryInOutInquiry;
  let lotBasedInventoryInOutInq = new DisplayModule(
    "lotBasedInventoryInOut",
    "LotBased Inventory InOut Inquiry",
    "LotBased Inventory InOut Inquiry",
    lotBasedInventory
  );
  tempModuleList.push(lotBasedInventoryInOutInq);

  let purchseOrderSummaryInfo = PurchaseOrderSummaryInfoInquiry;
  let poSummaryInfoInq = new DisplayModule(
    "poSummaryInfo",
    "PurchaseOrder Summary Info Inquiry",
    "PurchaseOrder Summary Info Inquiry",
    purchseOrderSummaryInfo
  );
  tempModuleList.push(poSummaryInfoInq);

  let invoiceSummaryReportInfo = InvoiceSummaryInfoInquiry;
  let invoiceInfoInq = new DisplayModule(
    "invoiceSummaryInfo",
    "Invoice Summary Info Inquiry",
    "Invoice Summary Info Inquiry",
    invoiceSummaryReportInfo
  );
  tempModuleList.push(invoiceInfoInq);
  
  let salesOrderSummaryReportInfo = SalesOrderSummaryInfoInquiry;
  let salesOrderInfoInq = new DisplayModule(
    "soSummaryInfo",
    "SalesOrder Summary Info Inquiry",
    "SalesOrder Summary Info Inquiry",
    salesOrderSummaryReportInfo
  );
  tempModuleList.push(salesOrderInfoInq);

  let pickTicketSummaryReportInfo = PickTicketSummaryInfoInquiry;
  let pickTicketInfoInq = new DisplayModule(
    "pickTicketSummaryInfo",
    "PickTicket Summary Info Inquiry",
    "PickTicket Summary Info Inquiry",
    pickTicketSummaryReportInfo
  );
  tempModuleList.push(pickTicketInfoInq);

  let poReceiptSummaryReportInfo = PurchaseOrderReceiptSummaryInfoInquiry;
  let receiptInfoInq = new DisplayModule(
    "prSummaryInfo",
    "PO Receipt Summary Info Inquiry",
    "PO Receipt Summary Info Inquiry",
    poReceiptSummaryReportInfo
  );
  tempModuleList.push(receiptInfoInq);
  
  let debitMemoMaintenance = DebitMemoMaintenanceModule;
  let debitMemoModule = new DisplayModule(
    "debitMemoModule",
    "DebitMemoMaintenanceModule",
    "DebitMemoMaintenanceModule",
    debitMemoMaintenance
  );
  tempModuleList.push(debitMemoModule);

  let creditMemoSummaryReportInfo = CreditMemoSummaryInfoInquiry;
  let creditMemoInfoInq = new DisplayModule(
    "creditMemoSummaryInfo",
    "CreditMemo Summary Info Inquiry",
    "CreditMemo Summary Info Inquiry",
    creditMemoSummaryReportInfo
  );
  tempModuleList.push(creditMemoInfoInq);
  
 let invoiceModel = InvoiceModelAttributeModule;
  let invoiceModelAtt = new DisplayModule(
    "invoiceModelAttribute",
    "Invoice Model",
    "Invoice Model",
    invoiceModel,
  );
  tempModuleList.push(invoiceModelAtt);  
  
let fabricStatisticsDetailModule = FabricStatisticsDetailMaintenance;
  let fabricStatisticsDetail = new DisplayModule(
    "fabricStatisticsDetailMaster",
    is3PL ? "Item Statistics Detail" : "Fabric Statistics Detail",
    is3PL ? "Item Statistics Detail" : "Fabric Statistics Detail",
    fabricStatisticsDetailModule
  );
  tempModuleList.push(fabricStatisticsDetail);  

  let salesYearlyInquiry = SalesYearlyInquiry;
  let salesYearlyInq = new DisplayModule(
    "salesYearly",
    "SalesYearlyInquiry",
    "SalesYearlyInquiry",
    salesYearlyInquiry
  );
  tempModuleList.push(salesYearlyInq);
  
  let fabricCatalogGeneration = FabricCatalogGeneration;
  let fabricCatalogInq = new DisplayModule(
    "fabricCatalog",
    "FabricCatalogGeneration",
    "FabricCatalogGeneration",
    fabricCatalogGeneration
  );
  tempModuleList.push(fabricCatalogInq);  

  return tempModuleList;
};
